import zhHans from 'vuetify/es5/locale/zh-Hans';
export default {
    ...zhHans,
    setting: {
        language: "Упрощенный китайский",
        dialogDetermine: "Конечно",
        dreivatives: "Доставка",
        markets: "Кавычки",
        assets: "ресурсы",
        liquidity: "Майнинг ликвидности",
        helpCentre: "Центр помощи",
        announcementCenter: "Центр объявлений",
        about: "о",
        bulletinCentre: "Центр объявлений",
        serviceAgreement: "Сервисное соглашение",
        support: "поддерживать",
        onlineSupportCustomerService: "Интернет Сервис",
        suggestionsAndFeedback: "Предложения и отзывы",
        service: "Служить",
        download: "скачать",
        coinApplication: "Приложение для листинга монет",
        privacyStatement: "Заявление о конфиденциальности",
        trade: "контрактная торговля",
        standardConteact: "Устойчивый",
        signOut: "выход",
        assetWallets: "Кошелек активов",
        financeRecords: "Записи об изменении учетной записи",
        identification: "Аутентификация",
        personalCenter: "Персональный центр",
        chooseLanguage: "Выберите язык",
        tips: "намекать",
        dark: "темный режим",
        light: "дневной режим",
        hosting: "Хостинг",
        languageTitle: "язык",
        convertCurrency: "Конвертировать валюту",
        cancel: "Отмена",
        aboutUs: "о нас",
        standard: "Непрерывность стандарта",
        share: "делиться",
        introduce: "Введение в платформу",
        set: "настраивать",
        changePassword: "Изменить пароль для входа",
        denomination: "Валюта котировки",
        color: "Цветовая конфигурация",
        code: "номер версии",
        color1: "Красный поднимается и зеленый падает",
        color2: "Зеленый поднимается, а красный падает",
        setLangue: "настройка языка",
        vip: "VIP-привилегии",
        vip2: "Текущий VIP-уровень",
        safeMenu: "Центр безопасности",
        conventional: "общепринятый",
        other: "другой",
        quickTips: "Добавьте до 3 функциональных кнопок быстрого доступа",
        quickTransaction: "Быстрая транзакция",
        safeConvenient: "Безопасно и удобно",
        timeSharing: "совместное времяпровождение",
        currentLevel: "текущий уровень",
        levelBenefits: "%{level} уровень дохода",
        teamLevel: "Уровень команды",
        levelLower: "%{level}подчиненный",
        rules: "Описание правила",
        bindWithdrawalAddress: "Привязать адрес вывода",
        tipsBindWithdrawalAddress: "Вы еще не привязали свой адрес вывода средств, сначала привяжите его.",
        walletAddressFormatIncorrect: "Неверный формат адреса кошелька",
        tradeRules1: "Прогнозируйте взлет и падение в будущем периоде. Цена на момент заказа используется в качестве начальной цены, а цена на последнюю секунду периода прогнозирования используется в качестве расчетной цены. Если расчетная цена превышает начальную цену, это означает увеличение. цена меньше стартовой, это означает снижение.",
        tradeRules2: "1.что такое контракт",
        tradeRules3: "Эта платформа предоставляет бессрочные контракты на основе USDT.Пользователи могут судить о росте или падении и выбирать, покупать длинные или продавать короткие контракты, чтобы получать прибыль от роста/падения цен на цифровые активы. У бессрочных контрактов нет даты поставки, и пользователи могут хранить их вечно.",
        tradeRules4: "2.Что такое маржа",
        tradeRules5: "На рынке виртуальных контрактов пользователям необходимо лишь заплатить небольшую сумму средств в определенной пропорции в соответствии с ценой контракта в качестве финансовой гарантии выполнения контракта, а затем они могут участвовать в покупке и продаже контракта. Такими средствами является депозит виртуального контракта. \nВ контрактах на этой платформе применяется модель отдельной маржи для отдельных счетов. Каждая валюта соответствует контрактному счету.Активы счетов и позиции в разных контрактных валютах независимы друг от друга, а переводы и транзакции между разными контрактными счетами не влияют друг на друга. После открытия контрактного счета пользователя риски и выгоды всех позиций, находящихся на контрактном счете, будут рассчитываться вместе.",
        tradeRules6: "3.Как рассчитать маржу",
        tradeRules7: "Маржа позиции = номинальная стоимость контракта * количество открытых контрактов / множитель кредитного плеча\nзамороженная маржа = сумма маржи всех успешно размещенных ордеров и открытых ордеров в текущем ордере\доступная маржа = баланс счета - маржа позиции - замороженная маржа",
        tradeRules8: "4.Как рассчитать ставку маржи",
        tradeRules9: "Ставка маржи является мерой риска активов пользователя. \nСтавка маржи = (Нереализованная прибыль и убыток + Маржа позиции + Доступная маржа + Заморозка маржи - Комиссия за ликвидацию) / Маржа позиции \nЧем меньше ставка маржи, тем выше риск счета. Когда ставка маржи меньше или равна 0%, будет запущена принудительная ликвидация.",
        tradeRules10: "5.Какова расчетная цена принудительного паритета?",
        tradeRules11: "Предполагаемая цена принудительной ликвидации, то есть цена, рассчитанная системой, которая теоретически запускает принудительную ликвидацию, носит справочный характер и может незначительно отклоняться от фактической стоимости.",
        tradeRules12: "6.Что такое общий капитал счета и нереализованная прибыль и убыток?",
        tradeRules13: "Общий баланс счета = баланс счета + нереализованная прибыль и убыток.\nНереализованная прибыль и убыток — это прибыль и убыток от позиции, которую в настоящее время занимает пользователь в валютном контракте. Нереализованная прибыль и убыток будут меняться в зависимости от последних изменений цены транзакции. \nНереализованная прибыль и убыток для длинных позиций = (1/средняя цена позиции - 1/цена последней сделки) * количество контрактов для длинных позиций * номинальная стоимость контракта * цена последней сделки \n нереализованная прибыль и убыток для коротких позиций = (1/ цена последней сделки - 1/ Средняя цена позиции) * Количество коротких контрактов * Номинальная стоимость контракта * Цена последней сделки",
        text1: "безопасность аккаунта",
        text2: "дневной и ночной режим",
        text3: "очистить кэш",
        text4: "Вы действительно хотите выйти?",
        text5: "Вы уверены, что хотите очистить кеш?",
        text6: "многоязычный",
        text7: "Для защиты вашей безопасности мы рекомендуем включить хотя бы одну двухфакторную аутентификацию."
    },
    login: {
        login: "Авторизоваться",
        register: "регистр",
        title1: "Торгуйте в любое время и в любом месте и просматривайте рыночные условия в режиме реального времени",
        title2: "Торгуйте в любое время и в любом месте и просматривайте рыночные условия в режиме реального времени",
        title3: "Самая надежная платформа для торговли криптовалютой",
        formTitle1: "Логин аккаунта",
        formTitle2: "Добро пожаловать! Войдите под своей электронной почтой, номером телефона",
        btn1: "телефон",
        btn2: "Почта",
        btn3: "Авторизоваться",
        btn4: "регистр",
        btn5: "забыл пароль?",
        field1: "Номер телефона",
        field2: "пароль",
        field3: "Почта",
        placeholder1: "нация",
        placeholder2: "Пожалуйста, введите номер телефона",
        placeholder3: "Пожалуйста введите пароль",
        placeholder4: "пожалуйста, введите свой адрес электронной почты",
        content12: "Пожалуйста, введите номер телефона",
        content13: "Пожалуйста введите пароль",
        content14: "пожалуйста, введите свой адрес электронной почты",
        content16: "Финансовые услуги цифровых активов",
        loginSuccess: "Авторизация успешна ",
        chooseArea: "Пожалуйста, выберите код города",
        placeholder5: "Пожалуйста, выберите код страны",
        placeholder6: "запомнить мой пароль",
        placeholder7: "Скачать приложение",
        placeholder8: "Свяжитесь со службой поддержки клиентов",
        placeholder9: "Выберите страну или регион",
        placeholder10: "код города",
        placeholder11: "Вход в кошелек",
        placeholder12: "Операция не удалась, пожалуйста, переключитесь на",
        placeholder13: "кошелек"
    },
    aboutUs: {
        aboutCoinbeadCenterTitle: "о",
        aboutCoinbeadCenterDetails: "Он имеет ведущую в мире платформу для торговли активами на блокчейне и управляет всей экосистемой.",
        footDetails1: "ежедневный объем торгов",
        footDetails2: "транзакций/секунду",
        footDetails3: "Центр помощи",
        coinbeadCenterTitle: "",
        coinbeadCenterDetails: "Это всемирно известный международный веб-сайт цифровых активов, который в основном предоставляет пользователям со всего мира монеты и производные от цифровых активов, такие как Биткойн (BTC), Litecoin (LTC) и Ethereum (ETH).",
        coinbeadCenterDetailsm: "Принимая передовые технологии, такие как GSLB, сетевые серверы, сетевые транзакции, сети, многомашинные высокоскоростные механизмы торговли памятью, холодные кошельки, интеллектуальные автономные горячие кошельки и т. д., мы обслуживаем наших клиентов с помощью нескольких терминалов, таких как веб-мобильные телефоны и ПК. Обеспечивать безопасные, стабильные и надежные услуги транзакций по цифровым тарифам. В то же время мы совершенствуем и обновляем продукты и услуги на основе предложений пользователей и потребностей, чтобы предоставлять более качественные услуги каждому клиенту, и нет конца улучшению инновационного пользовательского опыта.",
        infrastructureCenterTitle: "инфраструктура",
        infrastructureCenterDetails: "Наша миссия — предоставлять инфраструктурные услуги для всей экосистемы блокчейна.",
        freeCenterTitle: "бесплатно",
        freeCenterDetails: "Наше видение – обеспечить свободное движение денег по всему миру. Мы верим, что распространение этой свободы может сделать мир лучше.",
        futureCenterTitle: "Первопроходец в будущее технологий",
        futureCenterDetails: "Откройте будущее технологий",
    },
    applicationForListing: {
        title: "Приложение для листинга монет",
        projectName: "название проекта",
        tokenName: "Имя токена",
        projectDescription: "Описание Проекта",
        contractAddress: "Адрес контракта",
        officialWebsite: "Официальный веб-сайт",
        ContactAndEmail: "Почта для связи",
        ContactAndName: "Контактное лицо",
        file: "Загрузить вложение",
        pleaseEnter: "Пожалуйста входите",
        enterFile: "Пожалуйста, загрузите файлы",
        upload1: "В настоящее время ограничено выбором одного файла,",
        upload2: "На этот раз я выбрал",
        upload3: "файлы,",
        upload4: "Всего выбрано",
        upload5: "файлы",
    },
    public: {
        submit: "представлять на рассмотрение",
        copySuccessfully: "Скопировано успешно",
        copyFailed: "Не удалось скопировать",
        noDate: "Нет данных",
        submitSuccessfully: "Отправлено успешно",
        goBack: "вернуться на последнюю страницу",
        cancel: "Отмена",
        home: "титульная страница",
        loading: "загрузка...",
        confirm: "подтверждать",
        loadingFailed: "сетевая аномалия",
        nomore: "больше не надо",
        tryAgain: "Пожалуйста, обновите страницу/выйдите из программы и загрузите снова!",
        hot: "Популярные районы",
    },
    inviteFriends: {
        inviteFriends: "Поделиться с друзьями",
        freedomOfWealth: "Пусть богатство будет бесплатным вместе",
        myInvitationCode: "мой код приглашения",
        clickCopy: "Нажмите, чтобы скопировать",
        myInvitationLink: "Моя ссылка-приглашение",
        clicktoSaveTheQRCode: "Нажмите, чтобы сохранить QR-код",
        saveQRCode: "Пригласить QR-код",
        numberOfSubordinates: "Количество подчиненных",
        rebateIncome: "Доход со скидкой",
        people: "люди",
        myPromotionRevenue: "Мой рекламный доход",
        numberOfDirectSubordinates: "Количество прямых подчиненных",
        totalNumberOfSubordinates: "Общее количество подчиненных",
        directSubordinateReturnsCommission: "Комиссионная скидка для прямых подчиненных",
        theTotalCommission: "общая скидка",
        checkHistory: "Просмотр записей о скидках",
        history: "Запись комиссии",
        theLowerAccount: "Подчиненный аккаунт",
        type: "тип：",
        serviceCharge: "плата за обработку：",
        percentageofCommissionReturned: "Коэффициент скидки：",
        commissionrebateAmount: "Сумма скидки：",
        time: "время：",
        typeName1: "Пополнение и комиссия",
        typeName2: "Плата за обработку заказа MT, трехуровневое распределение",
        typeName3: "MT Выгодное трехуровневое распределение",
        typeName4: "Реферальные вознаграждения",
        typeName30: "Пополнение и комиссия",
        typeName31: "Периодическая скидка на торговую прибыль",
        typeName32: "Возврат прибыли за ликвидность при майнинге",
        typeName45: "Возврат комиссии за транзакцию",
        typeName46: "Комиссионная скидка на собственную плату за обработку",
        typeName50: "Скидка на комиссию за обработку контракта на поставку",
        typeName51: "Возврат комиссии за обработку бессрочного контракта",
        typeName52: "Дополнительная комиссионная скидка за обработку контракта на поставку",
        typeName53: "Дополнительная скидка на комиссию за обработку бессрочных контрактов",
        typeName54: "Дополнительные скидки на комиссию за обработку бессрочного контракта",
        shareRules1: "Инструкции по приглашению",
        shareRules2: "Войдите в центр приглашений, скопируйте ссылку или код приглашения и поделитесь им с друзьями. Друзья могут стать вашими подчиненными, зарегистрировавшись по вашему пригласительному коду.",
        shareRules3: "Зарабатывайте скидки",
        shareRules4: "При проведении транзакций подчиненными вы можете получать соответствующие комиссии, поддерживается до трех уровней подчиненных. Например, если вы приглашаете друга A, A приглашает B, а B приглашает C, то A, B и C могут заключать контракты и другие транзакции на платформе, и вы все можете получать соответствующие комиссионные.",
        shareRules5: "Уровень команды",
        shareRules6: "Чем больше подчиненных первого уровня вы продвигаете по службе, тем выше уровень команды и тем выше ваша скидка. Уровни команд разделены на LV1-LV6.Правила обновления показаны в таблице ниже, где «N» — количество подчиненных первого уровня, которые пополнили счет и завершили аутентификацию по настоящему имени.",
        shareRules7: "Когда подчиненные делают ставки на контракты на поставку, вы можете получать комиссионные пропорционально их ставкам.",
        upgradeConditions: "Требовать",
        recommendedNumberOfPeople: "Рекомендуемое количество человек"
    },
    suggestionsAndFeedback: {
        suggestionsAndFeedback: "Предложения и отзывы",
        text: "Если во время использования вы столкнулись с ошибками или у вас есть предложения по продукту, оставьте нам отзыв.",
        email: "Адрес электронной почты",
        enterEmail: "Пожалуйста, введите адрес электронной почты",
        enterCorrectEmail: "Пожалуйста, введите правильный адрес электронной почты",
        title: "заголовок",
        enterTitle: "Пожалуйста, введите название вопроса",
        describeTheProblem: "Опишите проблему",
        enterDescribeTheProblem: "Пожалуйста, введите проблему, которую вы описываете",
        submit: "представлять на рассмотрение",
    },
    help: {
        enterSearch: "поиск",
        title: "Центр помощи",
        search: "Пожалуйста, введите ваш вопрос",
        text1: "Понять ваши потребности и продолжать предоставлять вам более удобные услуги"
    },
    announcement: {
        enterSearch: "поиск",
        title: "Центр объявлений",
        search: "Пожалуйста, введите ваш вопрос"
    },
    privacy: {
        title: "Заявление о конфиденциальности",
        content1: "1. Какая личная информация о пользователях собирается?",
        content2: "Персональная информация собирается для предоставления продуктов и услуг и их постоянного улучшения.",
        content3: "Ниже приведены типы личной информации, которую мы собираем.：",
        content4: "Информация, которую вы нам предоставляете: Мы получаем и храним любую информацию, которую вы предоставляете в связи с Платформой. Вы можете не предоставлять определенную информацию, но в результате вы не сможете использовать определенные «услуги этой платформы». Примеры информации, которую вы нам предоставляете, включают:",
        content5: "Имя",
        content6: "адрес",
        content7: "Страна гражданства",
        content8: "удостоверение личности с фотографией",
        content9: "Номер мобильного телефона/номер электронной почты",
        content10: "Другая информация, которая помогает нам идентифицировать вас.",
        content11: "Автоматически собираемая информация: мы автоматически собираем и храним определенные типы информации об использовании вами Услуг Платформы. Как и многие веб-сайты, мы используем файлы cookie и другие уникальные идентификаторы. Мы получаем определенные типы информации, когда ваш веб-браузер или устройство получает доступ к Платформе. Примеры информации, которую мы собираем и анализируем, включают:",
        content12: "Адрес интернет-протокола (IP), который подключает персональный компьютер к Интернету;",
        content13: "Информация для входа, адрес электронной почты, пароль и местоположение личного устройства или компьютера;",
        content14: "Настройки версии и часового пояса;",
        content15: "История транзакций.",
        content16: "Информация из других источников: Мы можем собирать информацию о вас из других источников, таких как кредитная история из кредитных бюро. Мы будем использовать эту информацию для предотвращения и обнаружения мошенничества.",
        content17: "2. Можно ли его использовать детям?",
        content18: "Эта платформа не позволяет лицам младше 18 лет использовать «Сервис».",
        content19: "3. Для чего используются файлы cookie и другие идентификаторы?",
        content20: "Мы используем файлы cookie и аналогичные инструменты для оптимизации взаимодействия с пользователем, предоставления наших услуг и понимания того, как клиенты используют наши услуги, чтобы мы могли вносить целевые улучшения. Мы используем файлы cookie, чтобы наша система могла распознавать ваш браузер или устройство и предоставлять вам услуги.",
        content21: "Мы используем операционные файлы cookie и аналогичные инструменты (совместно именуемые «Файлы cookie») для предоставления таких услуг, как:",
        content22: "Чтобы идентифицировать вас, когда вы входите в систему и пользуетесь нашими услугами.",
        content23: "Предоставляйте индивидуальные функции и услуги.",
        content24: "Защититесь от мошеннических действий.",
        content25: "Улучшите безопасность.",
        content26: "Отслеживайте свои предпочтения (например, валюту и язык).",
        content27: "Мы также используем файлы cookie, чтобы понять, как пользователи используют наши услуги, и внести целевые улучшения.",
        content28: "4. Будет ли передана моя личная информация?",
        content29: "Информация о пользователях является важной частью нашего бизнеса, и мы не будем продавать личную информацию пользователей другим лицам. Эта платформа будет передавать личную информацию пользователей своим дочерним компаниям или филиалам только при следующих обстоятельствах: Эти дочерние компании или филиалы обязаны соблюдать настоящее заявление о конфиденциальности или, по крайней мере, следовать правилам, которые являются столь же защитными, как и меры защиты, описанные в этом заявлении о конфиденциальности.",
        content30: "Сторонние поставщики услуг: мы нанимаем другие компании и частных лиц для выполнения функций от нашего имени. Примеры таких функций включают: анализ данных, предоставление маркетинговой помощи, обработку платежей, передачу контента, а также оценку и управление кредитным риском. Эти сторонние поставщики услуг имеют доступ к личной информации, необходимой для выполнения своих функций, но не могут использовать ее для каких-либо других целей. Кроме того, они должны обрабатывать личную информацию в соответствии с настоящим заявлением о конфиденциальности и применимыми законами о защите данных.",
        content31: "Передача бизнеса: Поскольку наш бизнес продолжает расти, мы можем продавать или покупать другие предприятия или услуги. В таких транзакциях информация пользователя обычно входит в число передаваемых бизнес-активов, но остается предметом обещаний любого ранее существовавшего заявления о конфиденциальности (если, конечно, пользователь не соглашается на иное). Кроме того, если наша компания или практически все ее активы будут приобретены, информация о пользователях также будет передана. Защита нашей компании и других лиц: когда мы считаем, что раскрытие учетной записи и другой личной информации необходимо для соблюдения закона или наших нормативных обязательств, обеспечения соблюдения или применения наших Условий использования и других соглашений или прав, собственности или безопасности наших пользователи или другие лица. Когда мы опубликуем учетную запись и другую личную информацию. Это включает в себя обмен информацией с другими компаниями и организациями для защиты от мошенничества и снижения кредитного риска.",
        content32: "5. Международная передача персональных данных",
        content33: "Мы можем передавать ваши данные за пределы Европейской экономической зоны («ЕЭЗ»). Мы предпримем соответствующие меры безопасности, чтобы гарантировать, что такая передача соответствует применимым правилам защиты данных, если только Европейская комиссия не подтвердит, что страна, в которую передаются данные, обеспечивает адекватный уровень защиты.",
        content34: "6. В безопасности ли моя личная информация?",
        content35: "Мы разработали наши системы с учетом вашей безопасности и конфиденциальности. Мы используем протоколы шифрования и программное обеспечение, чтобы обеспечить безопасность личной информации во время ее передачи.",
        content36: "Мы всегда принимаем физические, электронные и процедурные меры безопасности при сборе, хранении и раскрытии личной информации. Наши процедуры безопасности означают, что нам может потребоваться подтвердить вашу личность, прежде чем раскрывать вам личную информацию.",
        content37: "Самое главное, что вы можете сделать, это защитить пароли личного кабинета от несанкционированного доступа. Мы рекомендуем установить уникальный пароль для вашей учетной записи, отличающийся от паролей других учетных записей в Интернете. И обязательно выйдите из системы после использования общего компьютера.",
        content38: "7. Как мне защитить личную информацию?",
        content39: "Если у вас есть какие-либо вопросы или возражения относительно того, как мы собираем и обрабатываем личную информацию, обратитесь к сотрудникам службы поддержки клиентов.",
        content40: "После того как вы согласитесь на обработку нами вашей личной информации для определенной цели, вы можете в любое время отказаться от своего намерения, и мы прекратим обработку ваших данных для этой цели.",
        content41: "Кроме того, вы имеете право запросить доступ, исправление и удаление персональных данных, а также запросить переносимость данных в соответствии с действующим законодательством. Вы также можете возразить против обработки нами ваших персональных данных или потребовать ограничить обработку ваших персональных данных при определенных обстоятельствах.",
        content42: "8. GDPR ЕС и Закон Великобритании о защите данных – правовая основа",
        content43: "GDPR ЕС и закон Великобритании о защите данных требуют от нас соблюдения правовой основы при использовании личной информации. Наша основа зависит от конкретных целей, для которых используется личная информация. К этим базам относятся:",
        content44: "Выполнение контракта – для предоставления вам продуктов или услуг или общения с вами по ним, включая использование нами вашей личной информации для приема и обработки заказов и обработки платежей.",
        content45: "Наши законные деловые интересы и интересы пользователей. Мы обнаруживаем и предотвращаем мошенничество и злоупотребления, чтобы защитить безопасность наших пользователей, нас самих или других.",
        content46: "Ваше согласие. Нам требуется ваше согласие на обработку вашей личной информации для конкретных целей, о которых вам сообщили. После того как вы дали нам свое согласие на обработку вашей личной информации для конкретной цели, вы можете в любое время отозвать свое согласие, и мы прекратим обработку ваших данных для этой цели.",
        content47: "Соблюдайте юридические обязательства. Мы используем вашу личную информацию в соответствии с требованиями закона. Например, мы собираем информацию о банковском счете в целях проверки личности.",
        content48: "Вышеуказанные и другие правовые основания зависят от конкретных целей, для которых мы используем личную информацию.",
        content49: "9. Условия использования, уведомления и изменения",
        content50: "Ваше использование и любые споры по поводу конфиденциальности регулируются настоящим Положением и нашими Условиями использования. Если у вас есть какие-либо опасения по поводу конфиденциальности этой платформы, свяжитесь с нами и дайте подробное объяснение, и мы будем рады решить эту проблему за вас. Вы также имеете право обратиться в местный орган по защите данных.",
        content51: "Наш бизнес постоянно меняется, как и наше заявление о конфиденциальности. Вам следует часто проверять наш сайт, чтобы видеть последние изменения. Если вы не согласны с измененным содержанием, вам следует немедленно прекратить доступ. После выпуска обновленной версии Политики конфиденциальности продолжение вашего доступа означает, что вы согласны с обновленным содержимым и соглашаетесь соблюдать обновленную Политику конфиденциальности. Если не указано иное, действующее Положение о конфиденциальности применяется ко всей информации о вас и вашей учетной записи, которую мы храним.",
    },
    serviceAgreement: {
        title: "Сервисное соглашение",
        content1: "Этот веб-сайт представляет собой платформу, предназначенную специально для пользователей, для проведения транзакций с цифровыми активами и предоставления сопутствующих услуг (далее именуемых «услуга» или «услуга»). Для удобства описания настоящего соглашения на этом веб-сайте в данном соглашении используется слово «мы» или другие местоимения от первого лица. Пока физическое лицо или другой субъект, который входит на веб-сайт, является пользователем этого веб-сайта, для удобства выражения этого соглашения ниже будет использоваться «вы» или другое второе лицо. Для удобства формулирования настоящего Соглашения мы и вы вместе именуемся в настоящем Соглашении «Стороны», а мы или вы по отдельности именуетесь «Сторона».",
        content2: "важный совет：",
        content3: "Настоящим мы специально напоминаем вам:",
        content4: "1 Сами цифровые активы не выпускаются каким-либо финансовым учреждением или компанией или этим веб-сайтом.",
        content5: "2 Рынки цифровых активов являются новыми, неподтвержденными и могут не расти;",
        content6: "3 Цифровые активы в основном широко используются спекулянтами и относительно мало используются на розничных и коммерческих рынках. Сделки с цифровыми активами чрезвычайно рискованны. Они торгуются непрерывно в течение дня, без ограничений на рост и падение, а цены легко зависят от рынка. производители и глобальная государственная политика.",
        content7: "4  Компания оставляет за собой право приостановить или прекратить действие вашей учетной записи в любое время, если Компания по своему усмотрению определит, что вы нарушили настоящее Соглашение или что услуги, предоставляемые этим веб-сайтом, или использование вами услуг, предоставляемых этим веб-сайтом, являются незаконно в соответствии с законодательством вашей юрисдикции, а также приостановить или прекратить использование вами услуг или транзакций с цифровыми активами, предоставляемых этим веб-сайтом. Людям из [материкового Китая, Тайваня, Израиля, Ирака, Бангладеш, Боливии, Эквадора, Кыргызстана, Севастополя и Великобритании (розничные пользователи)] запрещено использовать услуги контрактных транзакций, предоставляемые этим веб-сайтом. Вышеупомянутый список стран или регионов будет меняться в зависимости от политики и типов продуктов в разных странах или регионах. Мы не можем уведомить вас об этом специально. Пожалуйста, своевременно обращайте внимание на обновления этого соглашения.",
        content8: "Торговля цифровыми активами сопряжена с чрезвычайно высокими рисками и не подходит большинству людей. Вы понимаете и понимаете, что данная сделка может привести к частичной или полной потере, поэтому вам следует определить сумму сделки исходя из степени потерь, которую вы можете себе позволить. Вы знаете и понимаете, что цифровые активы создают производные риски, поэтому, если у вас есть какие-либо вопросы, рекомендуется сначала обратиться за помощью к профессиональным консультантам. Кроме того, помимо рисков, упомянутых выше, существуют и риски, которые невозможно предугадать. Прежде чем принимать какое-либо решение о покупке или продаже цифровых активов, вам следует тщательно обдумать и использовать четкое суждение, чтобы оценить свое финансовое положение и вышеупомянутые риски, и нести все возникающие в результате убытки. Мы не несем за это никакой ответственности.",
        content9: "Предупреждение для вас：",
        content10: "1 Вы понимаете, что этот веб-сайт используется только как место, где вы можете получить информацию о цифровых активах, найти участников сделки, провести переговоры и провести транзакции с цифровыми активами. Этот веб-сайт не участвует ни в одной из ваших транзакций, поэтому вам следует руководствоваться собственным разумным суждением. для определения соответствующих цифровых активов и/или транзакций или подлинности, законности и действительности информации и несет ответственность и убытки самостоятельно.",
        content11: "2 Любые мнения, новости, обсуждения, анализы, цены, рекомендации и другая информация на этом сайте являются общими комментариями рынка и не являются инвестиционными советами. Мы не несем ответственности за любые убытки, возникшие прямо или косвенно в результате использования этой информации, включая, помимо прочего, любую упущенную выгоду.",
        content12: "3 Этот веб-сайт оставляет за собой право принимать собственное решение, модифицировать или изменять содержимое в любое время. Мы приняли разумные меры для обеспечения точности информации на веб-сайте, но мы не можем гарантировать ее точность и не несем ответственности за любые убытки или ущерб, вызванные информацией на этом сайте или отсутствием информации.Прямые или косвенные убытки, возникающие в результате задержек или сбоев подключения к Интернету, передачи или получения любых уведомлений и информации.",
        content13: "4 Существуют также риски при использовании торговых систем на основе Интернета, включая, помимо прочего, сбои программного обеспечения, оборудования и подключения к Интернету. Поскольку мы не контролируем надежность и доступность Интернета, мы не несем ответственности за искажения, задержки и сбои соединения.",
        content14: "5 Запрещено использовать этот веб-сайт для участия в любой незаконной торговой деятельности или незаконной деятельности, такой как отмывание денег, контрабанда, коммерческий подкуп и т. д. Если будут обнаружены какие-либо подозрительные незаконные транзакции или незаконная деятельность, этот веб-сайт будет использовать различные доступные средства, в том числе не ограничиваясь блокированием счетов и уведомлением соответствующих сторон, органов власти и т. д., мы не принимаем на себя всю вытекающую из этого ответственность и оставляем за собой право требовать ответственности от соответствующих лиц.",
        content15: "6 Запрещается использовать этот веб-сайт для злонамеренного манипулирования рынком, неправомерных транзакций и другой неэтичной торговой деятельности. Если такие инциденты будут обнаружены, этот веб-сайт будет предупреждать, ограничивать транзакции и пресекать все неэтичные действия, такие как злонамеренное манипулирование ценами и злонамеренное влияние на Мы не берем на себя всю ответственность, возникающую в результате мер превентивной защиты, таких как блокировка учетной записи, и оставляем за собой право требовать ответственности от соответствующих лиц.",
        content16: "1. Общие принципы",
        content17: "1.1 «Пользовательское соглашение» (далее именуемое «настоящее Соглашение» или «Настоящие Условия») состоит из основного текста, «Условий конфиденциальности», «Знай своего клиента и политики борьбы с отмыванием денег» и различных других политик, которые были опубликованы или могут быть опубликованы в будущем на этом сайте.Правила классов, положения, описания и т. д.",
        content18: "1.2 Вам следует внимательно прочитать это соглашение, прежде чем пользоваться услугами, предоставляемыми этим сайтом.Если вы ничего не понимаете или если это необходимо по другим причинам, обратитесь к профессиональному юристу. Если вы не согласны с настоящим Соглашением и/или его изменением в любое время, немедленно прекратите использование услуг, предоставляемых этим веб-сайтом, или больше не входите на этот веб-сайт. Когда вы входите на этот веб-сайт, используете какие-либо услуги этого веб-сайта или совершаете любое другое подобное действие, это означает, что вы поняли и полностью согласились с содержанием настоящего Соглашения, включая любые изменения, внесенные этим веб-сайтом в настоящее Соглашение в любое время.",
        content19: "1.3 Вы можете стать участником этого сайта (далее «участник»), заполнив соответствующую информацию в соответствии с требованиями этого сайта и успешно зарегистрировавшись после других соответствующих процедур. Нажав кнопку «Согласен» во время регистрации. вы подписываете в электронной форме соглашение с компанией или когда вы нажимаете любую кнопку с пометкой «Согласен» или аналогичного значения во время использования этого веб-сайта или фактически используете услуги, предоставляемые этим веб-сайтом, другими способами, разрешенными этим веб-сайтом. , это означает, что вы полностью понимаете, соглашаетесь и принимаете все условия настоящего Соглашения. Отсутствие вашей собственноручной подписи не повлияет на юридическую силу настоящего Соглашения для вас.",
        content20: "1.4 Став участником этого веб-сайта, вы получите учетную запись участника и соответствующий пароль, которые хранятся у вас; вы несете юридическую ответственность за все действия и события, проводимые под вашей учетной записью.",
        content21: "1.5 Только участники, ставшие участниками этого веб-сайта, могут использовать платформу торговли цифровыми активами, предоставляемую этим веб-сайтом, для транзакций и пользоваться другими услугами, предусмотренными этим веб-сайтом, которые доступны только участникам; лица, не являющиеся членами, могут только входить на веб-сайт и просматривать веб-сайт. и другие услуги, предусмотренные данным сайтом.",
        content22: "1.6 Регистрируясь и используя любые услуги и функции, предоставляемые этим веб-сайтом, вы будете считать, что прочитали, поняли и:",
        content23: "1.6.1 Примите для себя все положения и условия настоящего Соглашения.",
        content24: "1.6.2 Вы подтверждаете, что вам больше 18 лет или вы достигли совершеннолетия для заключения договоров в соответствии с различными применимыми законами. Ваша регистрация на этом веб-сайте, продажи или покупки, публикация информации и т. д., а также принятие услуг этого веб-сайта должны соответствовать требованиям. с вашими требованиями. Обладать юрисдикцией в отношении соответствующих законов и правил суверенной страны или региона и иметь полную возможность принимать эти условия, заключать транзакции и использовать этот веб-сайт для проведения транзакций с цифровыми активами.",
        content25: "1.6.3 Вы гарантируете, что все принадлежащие вам цифровые активы, участвующие в сделке, получены законным путем и имеют право собственности.",
        content26: "1.6.4 Вы соглашаетесь с тем, что несете единоличную ответственность за свою торговую или неторговую деятельность, а также за любые прибыли или убытки.",
        content27: "1.6.5 Вы подтверждаете, что информация, предоставленная при регистрации, правдива и точна.",
        content28: "1.6.6 Вы соглашаетесь соблюдать требования любого соответствующего законодательства, в том числе сообщать о любой торговой прибыли для целей налогообложения.",
        content29: "1.6.7 Вы соглашаетесь не заниматься и не участвовать в поведении или деятельности, которые наносят ущерб интересам этого веб-сайта или компании, независимо от того, связаны они или нет с услугами, предоставляемыми этим веб-сайтом.",
        content30: "1.6.8 Настоящее соглашение регулирует только права и обязанности между вами и нами и не затрагивает правовые отношения и юридические споры, возникающие в результате транзакций с цифровыми активами между пользователями этого веб-сайта и других веб-сайтов и вами.",
        content31: "2. Изменения Соглашения",
        content32: "Мы оставляем за собой право время от времени пересматривать настоящее Соглашение и объявлять об этом на веб-сайте, не уведомляя вас отдельно.После пересмотра время пересмотра будет отмечено в поле [Время последнего обновления], отображаемом в настоящем Соглашении, и оно автоматически займет вступает в силу после публикации на веб-сайте. Вам следует время от времени просматривать и обращать внимание на время обновления и обновленное содержание настоящего Соглашения. Если вы не согласны с соответствующими изменениями, вам следует немедленно прекратить использование услуг этого веб-сайта; дальнейшее использование вами услуг настоящего Соглашения веб-сайт означает, что вы принимаете и соглашаетесь соблюдать пересмотренное соглашение.",
        content33: "3. Регистрация",
        content34: "3.1 Регистрационные квалификации",
        content35: "Вы подтверждаете и обещаете, что после завершения процесса регистрации или фактического использования услуг, предоставляемых этим веб-сайтом, другими способами, разрешенными этим веб-сайтом, вы должны иметь возможность подписать настоящее соглашение и использовать услуги этого веб-сайта, как это предусмотрено применимым законодательством. физическое лицо, юридическое лицо или другая организация. После того, как вы нажмете кнопку «Согласен на регистрацию», это означает, что вы или ваш уполномоченный агент согласились с содержанием соглашения и были зарегистрированы и использовали услуги этого веб-сайта своим агентом. Если вы не обладаете вышеупомянутыми квалификационными качествами, вы и ваш уполномоченный агент несете все вытекающие из этого последствия, и компания оставляет за собой право аннулировать или навсегда заморозить вашу учетную запись, а также привлечь вас и вашего уполномоченного агента к ответственности.",
        content36: "3.2 Цель регистрации",
        content37: "Вы подтверждаете и обещаете, что ваша регистрация на этом веб-сайте не предназначена для нарушения законов и правил или нарушения порядка транзакций с цифровыми активами на этом веб-сайте.",
        content38: "3.3 Процесс регистрации",
        content39: "3.3.1 Вы соглашаетесь предоставить действующий адрес электронной почты, номер мобильного телефона и другую информацию, необходимую на странице регистрации пользователя на этом веб-сайте. Вы можете использовать адрес электронной почты, номер мобильного телефона, который вы предоставили или подтвердили, или другие методы, разрешенные этим веб-сайтом, в качестве входа в систему. способ входа на этот сайт. При необходимости в соответствии с соответствующими законами и постановлениями различных юрисдикций вы должны предоставить свое настоящее имя, документ, удостоверяющий личность, и другую соответствующую информацию, предусмотренную законами и постановлениями, положениями о конфиденциальности и положениями о борьбе с отмыванием денег, а также постоянно обновлять регистрационную информацию в Своевременно, подробно и точно. Вся первоначально введенная информация будет считаться регистрационной информацией. Вы несете ответственность за достоверность, полноту и точность такой информации и несете любые прямые или косвенные убытки и возникающие из них неблагоприятные последствия.",
        content40: "3.3.2 Если законы, постановления, правила, приказы и другие нормативные акты суверенной страны или региона, где вы находитесь, требуют использования настоящего имени для номеров мобильных телефонов, вы соглашаетесь с тем, что предоставленный зарегистрированный номер мобильного телефона был зарегистрирован под настоящим именем. вы не предоставляете его в соответствии с правилами, любые причиненные вам последствия будут являться прямыми или косвенными убытками, а неблагоприятные последствия будут нести вы.",
        content41: "3.3.3 Если вы предоставляете информацию, необходимую для регистрации на законных основаниях, полностью и эффективно, и подтверждаете ее, вы имеете право получить номер учетной записи и пароль этого веб-сайта. Когда вы получаете номер учетной записи и пароль этого веб-сайта, ваша регистрация считается успешно, и вы можете войти в систему как участник на этом сайте.",
        content42: "3.3.4 Вы соглашаетесь получать электронные письма и/или короткие сообщения, отправленные с этого веб-сайта, связанные с управлением и работой этого веб-сайта.",
        content43: "4. Сервис",
        content44: "Этот веб-сайт предоставляет только услуги онлайн-торговой платформы для вашей деятельности по торговле цифровыми активами (включая, помимо прочего, торговлю цифровыми активами и другие услуги) через этот веб-сайт.",
        content45: "4.1 Сервисный контент",
        content46: "4.1.1 Вы имеете право просматривать рыночные условия и информацию о транзакциях различных продуктов с цифровыми активами на этом веб-сайте в режиме реального времени, а также право отправлять инструкции по транзакциям с цифровыми активами и совершать транзакции с цифровыми активами через этот веб-сайт.",
        content47: "4.1.2 Вы имеете право просматривать информацию в своей учетной записи на этом веб-сайте и применять для работы функции, предоставляемые этим веб-сайтом.",
        content48: "4.1.3 Вы имеете право участвовать в мероприятиях сайта, организуемых данным сайтом, в соответствии с правилами деятельности, опубликованными на этом сайте.",
        content49: "4.1.4 Этот веб-сайт обещает предоставить вам и другие услуги.",
        content50: "4.2 Правила обслуживания Вы обязуетесь соблюдать следующие правила обслуживания данного сайта:",
        content51: "4.2.1 Вы обязуетесь соблюдать законы, правила и требования политики, обеспечивать законность источников всех цифровых активов в вашей учетной записи и не участвовать в незаконных или других действиях, которые наносят ущерб правам и интересам этого веб-сайта или третьих лиц на этом веб-сайте. или используя его услуги, включая, помимо прочего: Вы не ограничены отправкой или получением любой незаконной, незаконной или нарушающей права других лиц, отправкой или получением финансовых пирамид или другой вредной информации или замечаний, использованием или подделкой электронной почты. информация заголовка на этом сайте без авторизации с этого сайта и т. д.",
        content52: "4.2.2 Вы должны соблюдать законы и правила, а также правильно использовать и хранить номер своего счета, пароль для входа, пароль фонда, номер мобильного телефона, привязанный к вам при регистрации, и код подтверждения мобильного телефона, полученный на ваш мобильный телефон. Вы несете полную ответственность за любые операции и последствия использования вашей учетной записи и пароля для входа, пароля фонда и кода подтверждения мобильного телефона. Если вы обнаружите, что номер счета этого веб-сайта, пароль для входа в систему, пароль фонда или код подтверждения используются третьей стороной без вашего разрешения или возникают другие проблемы с безопасностью учетной записи, вы должны немедленно и эффективно уведомить этот веб-сайт и попросить его приостановить обслуживание аккаунта этого сайта. . Этот сайт имеет право принять меры по вашему запросу в разумный срок, но этот сайт не несет никакой ответственности за последствия (включая, помимо прочего, любые понесенные вами убытки), которые произошли до принятия мер. Вы не имеете права дарить, одалживать, сдавать в аренду, передавать или иным образом распоряжаться своей учетной записью на этом веб-сайте другим лицам без согласия этого веб-сайта.",
        content53: "4.2.3 Вы соглашаетесь нести ответственность за все действия, которые происходят под вашей учетной записью и паролем на этом веб-сайте (включая, помимо прочего, раскрытие информации, публикацию информации, онлайн-клики для согласия или представления различных правил и соглашений, онлайн-продление соглашений или покупку услуги и др.).",
        content54: "4.2.4 При проведении транзакций с цифровыми активами на этом веб-сайте вы не должны злонамеренно вмешиваться в нормальный ход транзакций с цифровыми активами или нарушать порядок транзакций; вы не должны вмешиваться в нормальную работу этого веб-сайта или препятствовать использованию другими пользователями этого веб-сайта. услуги любыми техническими средствами или другими способами; вы не должны использовать фиктивные злонамеренные порочения репутации этого веб-сайта с помощью фактов и других средств.",
        content55: "4.2.5 Если у вас возник спор с другими пользователями из-за онлайн-транзакций, вы не можете запрашивать у этого веб-сайта соответствующую информацию по внесудебным или административным каналам.",
        content56: "4.2.6 Вы должны единолично судить и нести любые подлежащие уплате налоги, а также все расходы на оборудование, программное обеспечение, обслуживание и другие расходы, понесенные во время использования вами услуг, предоставляемых этим веб-сайтом.",
        content57: "4.2.7 Вы должны соблюдать настоящее соглашение и другие условия обслуживания и правила работы, публикуемые и обновляемые время от времени на этом веб-сайте, и имеете право прекратить использование услуг, предоставляемых этим веб-сайтом, в любое время.",
        content58: "4.3 правила продукта",
        content59: "4.3.1 Просмотр информации о транзакции",
        content60: "Когда вы просматриваете информацию о транзакциях на этом веб-сайте, вам следует внимательно прочитать все содержимое, содержащееся в информации о транзакции, включая, помимо прочего, цену, размер комиссии, комиссию за обработку, направление покупки или продажи, и только после того, как вы полностью примете все содержащееся содержимое. в информации о транзакции. Сделки можно совершать одним нажатием кнопки.",
        content61: "4.3.2 Посмотреть детали транзакции",
        content62: "Вы можете просмотреть соответствующие записи транзакций через свою учетную запись.",
        content63: "5. Права и обязанности этого сайта",
        content64: "5.1 Если у вас нет регистрационных требований, предусмотренных в настоящем соглашении, этот веб-сайт имеет право отказать вам в регистрации. Для тех, кто уже зарегистрировался, этот веб-сайт имеет право аннулировать вашу членскую учетную запись. Этот веб-сайт оставляет за собой право задержать вас или Ответственность за это несет ваш уполномоченный агент. Это правда. В то же время этот веб-сайт оставляет за собой право решать, принимать ли вашу регистрацию при любых других обстоятельствах.",
        content65: "5.2 По собственному мнению этого веб-сайта, если этот веб-сайт обнаружит, что вы или пользователи связанной с вами учетной записи не подходите для инвестиций с высоким уровнем риска, мы имеем право приостановить или прекратить действие вашей учетной записи и использования всех связанных учетных записей.",
        content66: "5.3 Когда этот веб-сайт обнаруживает, что пользователь учетной записи не является первоначальным владельцем учетной записи, он имеет право приостановить или прекратить использование учетной записи.",
        content67: "5.4 Когда этот веб-сайт обоснованно подозревает, что предоставленная вами информация является неправильной, неверной, недействительной или неполной в результате технического тестирования, выборки вручную и других методов тестирования, он имеет право уведомить вас о необходимости исправить или обновить информацию или приостановить или прекратить предоставление этот сайт обслуживает вас.",
        content68: "5.5 Этот веб-сайт оставляет за собой право исправлять любую информацию, отображаемую на этом веб-сайте, если обнаружится очевидная ошибка.",
        content69: "5.6 Этот веб-сайт оставляет за собой право изменять, приостанавливать или прекращать услуги этого веб-сайта в любое время. Этот веб-сайт не должен уведомлять вас заранее, чтобы воспользоваться правом на изменение или прекращение услуг. Если этот веб-сайт прекращает работу одной или нескольких служб этого веб-сайта, прекращение будет осуществляться с этого веб-сайта на веб-сайте. Вступает в силу с даты публикации объявления о прекращении действия.",
        content70: "5.7 Этот веб-сайт будет использовать необходимые технические средства и меры управления для обеспечения нормальной работы этого веб-сайта, предоставления необходимой и надежной торговой среды и торговых услуг, а также поддержания порядка транзакций с цифровыми активами.",
        content71: "5.8 Если вы не войдете на этот веб-сайт, используя свою учетную запись и пароль в течение одного года подряд, этот веб-сайт имеет право аннулировать вашу учетную запись. После удаления учетной записи этот веб-сайт имеет право открыть соответствующее имя участника другим пользователям для регистрации и использования.",
        content72: "5.9 Этот веб-сайт обеспечивает безопасность ваших цифровых активов за счет увеличения инвестиций в технологии, улучшения мер безопасности и других мер, а также заранее уведомит вас, когда в вашей учетной записи возникнут предсказуемые угрозы безопасности.",
        content73: "5.10 Этот веб-сайт имеет право в любое время удалить все виды информации на этом веб-сайте, которая не соответствует законам и правилам или правилам этого веб-сайта. Этот веб-сайт не должен уведомлять вас заранее, чтобы воспользоваться такими правами.",
        content74: "5.11 Этот веб-сайт имеет право запросить у вас дополнительную информацию или материалы в соответствии с законами, постановлениями, правилами, приказами и другими нормативными требованиями вашей суверенной страны или региона, а также принять разумные меры для соблюдения местных нормативных требований. обязаны сотрудничать; этот веб-сайт имеет право приостановить или навсегда прекратить предоставление вам некоторых или всех услуг этого веб-сайта в соответствии с требованиями законов, постановлений, правил, приказов и других спецификаций вашей суверенной страны или региона.",
        content75: "5.12 Этот веб-сайт оставляет за собой право закрыть вашу учетную запись с уведомлением за семь рабочих дней по своему усмотрению. Таким образом, у вас есть семь рабочих дней на отмену ордеров и закрытие позиций. Если вы не отменили заказ и не закрыли позицию по истечении этого периода, мы принудительно отменим заказ и закроем позицию, а также вернем вам оставшиеся цифровые активы на вашем счету.",
        content76: "5.13 В целях защиты прав и интересов трейдеров этот веб-сайт имеет право вносить изменения в онлайн-продукты при особых обстоятельствах (таких как сбой системы, сбой сети, экстремальные рыночные условия и т. д.), таких как: контракты на досрочную поставку и расчет, типы контрактов и контракты на досрочную поставку и расчет.Период, а также расчет и цена доставки подлежат объявлению на этом веб-сайте.",
        content77: "6. Компенсация",
        content78: "6.1 Ни при каких обстоятельствах наша ответственность перед вами за прямой ущерб не будет превышать общую плату за обслуживание, которую мы взимали с вас за использование вами этого веб-сайта в течение трех (3) месяцев.",
        content79: "6.2 Если вы нарушаете настоящее Соглашение или другие законы и правила, вы должны компенсировать нам не менее 2 миллионов долларов США и нести все понесенные расходы (включая гонорары адвокатов и т. д.). Если этого недостаточно для компенсации фактических убытков, вы должны сделать готов к этому.",
        content80: "7. Право требовать судебного запрета",
        content81: "Мы и вы оба признаем, что средства правовой защиты по общему праву в случае нарушения вами договора или возможного нарушения договора могут оказаться недостаточными для компенсации всех понесенных нами убытков, поэтому мы имеем право требовать судебного запрета, разрешенного общим правом или справедливостью в в случае нарушения вами договора или возможного нарушения договора, все другие средства правовой защиты.",
        content82: "8. Ограничение ответственности и отказ от ответственности",
        content83: "8.1 Вы понимаете и соглашаетесь, что ни при каких обстоятельствах мы не несем ответственности за следующие вопросы:",
        content84: "8.1.1 потеря дохода;",
        content85: "8.1.2 торговая прибыль или убытки по контракту;",
        content86: "8.1.3 Убытки, вызванные перерывом в деятельности;",
        content87: "8.1.4 потеря ожидаемых денежных сбережений;",
        content88: "8.1.5 Потери, вызванные информационными проблемами;",
        content89: "8.1.6 потеря возможности, доброй воли или репутации;",
        content90: "8.1.7 повреждение или потеря данных;",
        content91: "8.1.8 стоимость приобретения товаров-заменителей или услуг;",
        content92: "8.1.9 Любые косвенные, особые или случайные убытки или ущерб, возникающие в результате правонарушения (включая халатность), нарушения договора или по любой другой причине, независимо от того, можем ли мы разумно предвидеть такие убытки или ущерб; независимо от того, были ли мы проинформированы о существовании таких заранее Возможность потери или повреждения.",
        content93: "8.1.1 Статьи 8.1.9 независимы друг от друга.",
        content94: "8.2 Вы понимаете и соглашаетесь с тем, что мы не несем ответственности за любой ущерб, причиненный вам в результате любого из следующих обстоятельств:",
        content95: "8.2.1 Ваши конкретные транзакции могут сопровождаться серьезными нарушениями законов или контрактов.",
        content96: "8.2.2 Ваше поведение на этом сайте может быть незаконным или неэтичным.",
        content97: "8.2.3 Затраты и убытки, понесенные в результате покупки или получения каких-либо данных, информации или проведения транзакций через сервисы этого сайта или заменяющие действия.",
        content98: "8.2.4 Ваше непонимание услуг этого сайта.",
        content99: "8.2.5 Любые другие убытки, связанные с услугами, предоставляемыми этим сайтом, не по нашей вине.",
        content100: "8.3 Мы несем ответственность за обслуживание оборудования информационной сети, сбой подключения к информационной сети, сбой компьютера, связи или другой системы, сбой в электроснабжении, погодные условия, несчастные случаи, забастовки, трудовые споры, массовые беспорядки, восстания, массовые беспорядки, недостаточную производительность или производственные материалы, пожар, наводнение. , штормы, взрывы, войны, причины банков или других партнеров, обвал рынка цифровых активов, действия правительства, приказы судебных или административных органов, другие действия, которые находятся вне нашего контроля или которые мы не можем контролировать, или причины третьих лиц. не берем на себя никакой ответственности за невозможность или задержку обслуживания, а также за ваши убытки.",
        content101: "8.4 Мы не можем гарантировать, что вся информация, программы, тексты и т. д., содержащиеся на этом сайте, полностью безопасны и не будут повреждены и уничтожены какими-либо вирусами, троянскими конями и другими вредоносными программами.Поэтому, если вы входите в систему и пользуетесь какими-либо услугами на Этот веб-сайт или загрузка и использование любых загруженных программ, Информация, данные и т. д. являются вашими собственными решениями, и вы несете риски и возможные убытки на свой страх и риск.",
        content102: "8.5 Мы не даем никаких гарантий или обязательств в отношении какой-либо информации, продуктов и услуг каких-либо сторонних веб-сайтов, связанных с этим веб-сайтом, или любой другой формы контента, который не принадлежит нам.Если вы используете какие-либо услуги, информацию и услуги, предоставляемые третьими лицами Сторонние веб-сайты, Продукты и т. д. — это все ваши собственные решения, и вы несете всю вытекающую из них ответственность.",
        content103: "8.6 Мы не даем никаких явных или подразумеваемых гарантий использования вами услуг на этом веб-сайте, включая, помимо прочего, пригодность услуг, предоставляемых этим веб-сайтом, отсутствие ошибок или упущений, непрерывность, точность, надежность и пригодность для конкретного пользователя. цель. В то же время мы не берем на себя никаких обязательств и не гарантируем достоверность, точность, правильность, надежность, качество, стабильность, полноту и актуальность технологий и информации, задействованных в услугах, предоставляемых этим веб-сайтом. Заходить ли в систему или использовать услуги, предоставляемые этим сайтом, является вашим личным решением, и вы несете свои собственные риски и возможные убытки. Мы не даем никаких явных или подразумеваемых гарантий относительно рынка, стоимости и цены цифровых активов.Вы понимаете и понимаете, что рынок цифровых активов нестабильен.Цены и стоимости могут значительно колебаться или обрушиваться в любое время.Торговля цифровыми активами Ваша личная свобода.Выбирайте и принимайте решение на свой страх и риск и возможные потери.",
        content104: "8.7 Наши гарантии и обязательства, изложенные в настоящем Соглашении, являются единственными гарантиями и заявлениями, сделанными нами в отношении настоящего Соглашения и услуг, предоставляемых на этом веб-сайте, и заменяют собой любые гарантии и обязательства, возникающие любым другим способом и способом, будь то письменные или устные, явные или подразумеваемого. Все эти гарантии и заявления представляют собой только наши собственные обязательства и гарантии и не гарантируют, что какая-либо третья сторона будет соблюдать гарантии и обязательства по настоящему Соглашению.",
        content105: "8.8 Мы не отказываемся от каких-либо прав, не упомянутых в настоящем Соглашении, позволяющих ограничить, исключить или компенсировать нашу ответственность за ущерб в максимальной степени применимого законодательства.",
        content106: "8.9 После регистрации вы соглашаетесь на любые операции, которые мы выполняем в соответствии с правилами, предусмотренными настоящим соглашением, и любые возникающие риски несете вы.",
        content107: "9. Расторжение Соглашения",
        content108: "9.1 Этот веб-сайт имеет право прекратить все услуги этого веб-сайта в соответствии с настоящим соглашением. Настоящее соглашение будет расторгнуто в день, когда все услуги этого веб-сайта будут прекращены.",
        content109: "9.2 После прекращения действия настоящего соглашения вы не имеете права требовать от этого веб-сайта продолжать предоставлять ему какие-либо услуги или выполнять любые другие обязательства, включая, помимо прочего, требование от этого веб-сайта сохранять или раскрывать вам любую информацию в его исходной учетной записи веб-сайта. вам или третьему лицу. Третья сторона передает любую информацию, которую она не прочитала и не отправила.",
        content110: "9.3 Прекращение действия настоящего соглашения не повлияет на другие обязанности стороны, не нарушившей соглашение, перед нарушившей стороной.",
        content111: "10. Права интеллектуальной собственности",
        content112: "10.1 Все интеллектуальные достижения, содержащиеся на этом веб-сайте, включают, помимо прочего, логотипы веб-сайтов, базы данных, дизайн веб-сайтов, текст и графику, программное обеспечение, фотографии, видео, музыку, звуки и их комбинации, компиляции программного обеспечения, соответствующие исходные коды и программное обеспечение (включая небольшие приложения). ) Права интеллектуальной собственности на программы и скрипты принадлежат этому сайту. Вы не имеете права воспроизводить, изменять, копировать, отправлять или использовать любые вышеперечисленные материалы или контент в коммерческих целях.",
        content113: "10.2 Все права, содержащиеся в названии этого сайта (включая, помимо прочего, деловую репутацию, товарные знаки и логотипы), принадлежат компании.",
        content114: "10.3 Ваше согласие с настоящим соглашением будет рассматриваться как ваша инициатива по передаче авторских прав на любую форму информации, которую вы публикуете на этом веб-сайте, включая, помимо прочего: права на воспроизведение, права на распространение, права на прокат, права на выставку, права на исполнение, права на показ, права на трансляцию, права на передачу информации в Интернете, права на киносъемку, права на адаптацию, права на перевод, права на компиляцию и другие передаваемые права, которыми должен обладать владелец авторских прав, передаются исключительно этому веб-сайту бесплатно. Этот веб-сайт имеет право подать независимую подать иск против любого субъекта за нарушение и получить полную компенсацию. Настоящее соглашение действительно для любого рабочего контента, защищенного законом об авторском праве, который вы публикуете на этом сайте, независимо от того, сформирован ли контент до подписания настоящего соглашения или после его подписания.",
        content115: "10.4 Вы не имеете права незаконно использовать или распоряжаться правами интеллектуальной собственности этого веб-сайта или других лиц при использовании услуг этого веб-сайта. Вы не имеете права публиковать или разрешать другим веб-сайтам (и средствам массовой информации) использовать информацию, опубликованную на этом сайте, в любой форме.",
        content116: "11. Защита информации",
        content117: "Положения «Условий конфиденциальности», опубликованных отдельно на этом веб-сайте, имеют преимущественную силу.",
        content118: "12. Расчет",
        content119: "Все результаты расчета транзакций проверены нами, и все методы расчета опубликованы на веб-сайте, однако мы не можем гарантировать, что использование веб-сайта не будет прерываться или быть безошибочным.",
        content120: "13. Экспортный контроль",
        content121: "Вы понимаете и признаете, что в соответствии с соответствующими законами вам не разрешается экспортировать, реэкспортировать, импортировать или передавать любые материалы (включая программное обеспечение) на этом веб-сайте, поэтому вы гарантируете, что не будете активно внедрять, помогать или участвовать в каком-либо из вышеупомянутый экспорт или связанная с ним деятельность, которая нарушает законы и правила.Передача или другие нарушения применимых законов и правил; если такая ситуация обнаружена, вы должны своевременно сообщить нам об этом и помочь нам в ее решении.",
        content122: "14. Трансфер",
        content123: "Права и обязанности, предусмотренные настоящим Соглашением, также обязательны для правопреемников, наследников, исполнителей и администраторов сторон, которые получают выгоду от таких прав и обязанностей. Вы не можете передавать его какой-либо третьей стороне без нашего согласия, но мы можем передать наши права и обязанности по настоящему Соглашению любой третьей стороне в любое время и уведомить вас об этом.",
        content124: "15. Делимость",
        content125: "Если какое-либо положение настоящего Соглашения будет признано судом компетентной юрисдикции не имеющим исковой силы, недействительным или незаконным, это не повлияет на действительность остальных положений настоящего Соглашения.",
        content126: "16. Неагентские отношения",
        content127: "Ничто в настоящем Соглашении не может рассматриваться как создающее, подразумевающее или иным образом делающее нас вашим агентом, доверенным лицом или другим представителем, за исключением случаев, предусмотренных настоящим Соглашением.",
        content128: "17. Воздержание",
        content129: "Отказ нами или вами от ответственности какой-либо стороны за нарушение договора или другой ответственности, предусмотренной в настоящем Соглашении, не должен рассматриваться или интерпретироваться как отказ от другой ответственности за нарушение договора; неисполнение какого-либо права или средства правовой защиты ни в коем случае не должно рассматриваться или интерпретироваться как отказ от другой ответственности за нарушение договора. образом может быть истолковано как отказ от таких прав или средств правовой защиты.",
        content130: "18. Название",
        content131: "Все заголовки предназначены исключительно для удобства выражения соглашения и не используются для расширения или ограничения содержания или объема условий соглашения.",
        content132: "19. Применимое право",
        content133: "19.1 Прежде чем поднимать спор или претензию, вы признаете и соглашаетесь сначала связаться с этим веб-сайтом по электронной почте, чтобы разрешить спор неофициально. Мы постараемся разрешить ваш спор внутри компании как можно скорее; обе стороны соглашаются разрешить спор путем добросовестных переговоров (обсуждения должны быть конфиденциальными и защищены применимыми правилами и не использоваться в качестве доказательства в каких-либо судебных разбирательствах).",
        content134: "19.2 Вы признаете и соглашаетесь, что в случае любого спора, разногласия, разногласия или претензии, включая существование, действительность, интерпретацию, исполнение, нарушение или прекращение действия настоящих Условий или любого спора, возникающего из или в связи с настоящими Условиями («Спор» ) , вышеупомянутые стороны передают спор в Международный арбитражный суд Международной торговой палаты («Международный арбитражный суд ICC») в соответствии с действующими на тот момент «Арбитражными правилами ICC». Местом арбитражного разбирательства является Белиз, а применимое право арбитражного разбирательства определяется в соответствии с Арбитражным регламентом Международной торговой палаты. Если стороны не договорились об ином, в соответствии с Арбитражным регламентом ICC будет назначен только один арбитр. Арбитр имеет исключительные полномочия выносить решения о своей юрисдикции, включая, помимо прочего, любые возражения против существования, объема или действительности арбитражного соглашения или возможности арбитражного урегулирования любого иска или встречного иска. Любой арбитраж будет проводиться на английском языке. Независимо от того, как проводится арбитраж, арбитр выносит письменное решение, которое является разумным и достаточным для объяснения решения и основных выводов, если таковые имеются, на которых основано решение. Арбитражное решение является окончательным и обязательным для сторон и может быть приведено в исполнение в любом суде компетентной юрисдикции.",
        content135: "20. Действительность и толкование соглашения",
        content136: "20.1 Настоящее соглашение вступает в силу, когда вы нажимаете на страницу регистрации этого веб-сайта, чтобы согласиться зарегистрироваться, завершить процесс регистрации и получить учетную запись и пароль для этого веб-сайта. Оно является обязательным как для этого веб-сайта, так и для вас.",
        content137: "20.2 Право на окончательную интерпретацию настоящего соглашения принадлежит этому веб-сайту.",
        content138: "Знайте своих клиентов и политику борьбы с отмыванием денег",
        content139: "1. Введение",
        content140: "1.1 Мы обещаем тщательно соблюдать законы и правила, касающиеся «Знай своего клиента» и борьбы с отмыванием денег, и не будем намеренно нарушать «Политику «Знай своего клиента и борьбу с отмыванием денег». В рамках нашего разумного контроля мы примем необходимые меры и технологии, чтобы предоставить вам безопасные услуги и максимально защитить вас от убытков, вызванных поведением подозреваемых в отмывании денег.",
        content141: "1.2 Наша Политика «Знай своего клиента» и «Правила борьбы с отмыванием денег» представляет собой комплексную международную систему политик, которая включает в себя политики «Знай своего клиента» и «Правила борьбы с отмыванием денег» для различных правовых юрисдикций, к которым вы принадлежите.",
        content142: "2. Знайте своих клиентов и придерживайтесь следующих политик по борьбе с отмыванием денег:",
        content143: "2.1 Обнародовать политику «знай своего клиента» и политику борьбы с отмыванием денег и время от времени обновлять ее, чтобы она соответствовала стандартам, установленным соответствующими законами и постановлениями;",
        content144: "2.2 Обнародовать и обновить некоторые руководящие принципы и правила работы этого веб-сайта, и наши сотрудники будут предоставлять услуги в соответствии с этими принципами и правилами;",
        content145: "2.3 Разработать и завершить процедуры внутреннего мониторинга и контроля транзакций, такие как строгая проверка личности и организация формирования профессиональной команды, которая будет отвечать за работу по борьбе с отмыванием денег;",
        content146: "2.4 Использовать методы предотвращения рисков для проведения комплексной проверки и постоянного надзора за клиентами;",
        content147: "2.5 Просмотр и регулярная проверка произошедших транзакций;",
        content148: "2.6 Сообщать о подозрительных операциях компетентным органам;",
        content149: "2.7 Подтверждение личности, адрес и записи транзакций будут храниться не менее шести лет и могут быть переданы в регулирующие органы без дополнительного уведомления.",
        content150: "3. Информация о личности и проверка",
        content151: "3.1 Идентификационная информация",
        content152: "3.1.1 В соответствии с различными правилами в разных юрисдикциях и разных типах организаций содержание вашей информации, которую мы собираем, может быть противоречивым.В принципе, следующая информация будет собираться от зарегистрированных физических лиц:",
        content153: "Основная личная информация: ваше имя, адрес (и постоянный адрес, если он отличается), дата рождения и гражданство, а также другая доступная информация. Проверка личности должна основываться на документах, выданных официальными или другими аналогичными органами, таких как паспорта, удостоверения личности или другие документы, удостоверяющие личность, требуемые и требуемые различными юрисдикциями. Предоставленный вами адрес будет проверен с использованием соответствующих методов, таких как проверка билета на пассажирский транспорт или процентной ставки, или проверка списка избирателей.",
        content154: "Действительная фотография: перед регистрацией вы должны предоставить фотографию, на которой вы держите удостоверение личности на груди;",
        content155: "Контактная информация: номер телефона/мобильного телефона и/или действующий адрес электронной почты.",
        content156: "3.1.2 Если вы являетесь корпорацией или другим юридическим лицом, мы соберем следующую информацию, чтобы идентифицировать вас или конечного бенефициара вашего трастового счета.",
        content157: "Регистрация компании и свидетельство о регистрации; копии устава и меморандума компании; подробные сертификационные материалы о структуре акционерного капитала компании и описании собственности, подтверждающие решение совета директоров уполномоченного принципала, который определяет открытие и исполнение счета на этом веб-сайте; компания директора, которых необходимо предоставить по мере необходимости, документы, удостоверяющие личность основного акционера и лица, уполномоченного подписывать учетную запись на этом веб-сайте; основной рабочий адрес компании, если он отличается от почтового адреса компании, укажите почтовый адрес. Если местный адрес компании не соответствует ее основному служебному адресу, она считается клиентом с повышенным риском и должна будет предоставить дополнительную документацию.",
        content158: "В зависимости от различных правил в разных юрисдикциях и разных типах организаций нам требуются другие сертификаты и документы, выданные властями, а также документы, которые мы считаем необходимыми.",
        content159: "3.1.3 Мы принимаем только английские или китайские версии идентификационной информации. В противном случае переведите свою идентификационную информацию на английский язык и нотариально заверьте ее.",
        content160: "3.2 Подтвердить проверку",
        content161: "3.2.1 Мы требуем, чтобы вы предоставили полное содержание страницы вашего документа, удостоверяющего личность.",
        content162: "3.2.2 Мы просим вас сфотографироваться, прижимая к груди документ, удостоверяющий личность.",
        content163: "3.2.3 Копии подтверждающих документов обычно следует сверять с оригиналами ваучеров. Однако копия принимается, если подходящий и заслуживающий доверия орган по сертификации может подтвердить, что копия является точным и полным воспроизведением оригинального документа. К таким удостоверяющим лицам относятся послы, судебные комиссары, местные судьи и т. д.",
        content164: "3.2.4 Требование по определению конечного бенефициара и контроля над счетом состоит в том, чтобы определить, какие лица в конечном итоге владеют прямым клиентом или контролируют его, и/или установить, что текущие транзакции выполняются от имени других. Если это бизнес, необходимо подтвердить личность основных акционеров (например, тех, кто владеет 10% или более голосующих акций). Как правило, владение 25% акций будет считаться нормальным риском, и личность акционера должна быть проверена; владение 10% акций или большим количеством прав голоса или акций считается ситуацией высокого риска, и личность акционера акционера должны быть проверены.",
        content165: "4. Мониторинг транзакций",
        content166: "4.1 Мы время от времени устанавливаем и корректируем максимальные лимиты ежедневных транзакций и снятия валюты в зависимости от безопасности и фактических условий транзакций;",
        content167: "4.2 Если транзакции происходят часто у зарегистрированного пользователя или возникают необоснованные обстоятельства, наша профессиональная команда оценит и решит, являются ли они подозрительными;",
        content168: "4.3 Если мы определим, что транзакция является подозрительной на основании нашего собственного суждения, мы можем принять ограничительные меры, такие как приостановка транзакции, отклонение транзакции или даже отменить транзакцию как можно скорее, если это возможно, и сообщить об этом компетентному органу, но не уведомит вас;",
        content169: "4.4 Мы оставляем за собой право отклонить заявки на регистрацию от лиц из юрисдикций, которые не соответствуют международным стандартам по борьбе с отмыванием денег, или от лиц, которые могут считаться политически значимыми лицами. Мы оставляем за собой право приостановить или прекратить транзакции, которые, по нашему единоличному мнению, являются подозрительными по адресу в любое время, но мы не делаем этого.Нарушать любые обязанности или ответственность, возложенную на вас.",
    },
    register: {
        formTitle1: "создавать",
        formTitle2: "Зарегистрируйтесь, используя адрес электронной почты или номер мобильного телефона",
        formTitle3: "Счет",
        field1: "Проверочный код",
        field2: "получа",
        field3: "Подтвердите пароль",
        field4: "Код приглашения",
        field41: "（Необязательный）",
        field5: "Я прочитал и согласен",
        field6: "Условия использования",
        placeholder1: "пожалуйста, введите код подтверждения",
        content7: "пожалуйста, введите код подтверждения",
        content12: "Пожалуйста, введите номер телефона",
        content13: "Пожалуйста введите пароль",
        content14: "пожалуйста, введите свой адрес электронной почты",
        content18: "Пожалуйста, введите пароль еще раз",
        content19: "Пожалуйста, согласитесь с условиями обслуживания",
        content20: "Пожалуйста, введите правильный код подтверждения",
        content23: "Все еще не получили код подтверждения?",
        content24: "Пожалуйста, введите код подтверждения ниже",
        registerSuccess: "Вы успешно зарегистрировались",
        content25: "Пароли несовместимы",
        content26: "Пожалуйста, введите правильный адрес электронной почты",
        content27: "Сброс пароля успешен"
    },
    download: {
        content1: "Торгуйте в любое время и в любом месте",
        content2: "Идеально совместим с несколькими терминалами, удовлетворяя потребности транзакций в различных сценариях в любое время.",
        content3: "Проверяйте рыночные условия в режиме реального времени в любое время",
        content4: "Легко покупайте и продавайте BTC, ETH, XRP и другие цифровые активы.",
        content5: "Получайте ранние предупреждения об изменении цен на интересующие вас криптовалюты.",
        content6: "Просмотр спотового кредита на биткойны, фьючерсного кредита и цен опционов",
        content7: "Сравните цены на криптовалюту на различных биржах",
        title: "скачать",
        install: "Примечания по установке",
        one: "1. Разрешить загрузку файлов описания",
        two: "2. Файл описания скачан.",
        three: "3. Войдите в [Настройки] на своем телефоне и найдите [Общие].",
        four: "4. Описание файлов и диспетчера устройств",
        five: "5. Нажмите на файл описания.",
    },
    identity: {
        noAuthentication: {
            title: "Младшая сертификация",
            pleaseSelectYourCountry: "Пожалуйста, выберите вашу страну",
            name: "Имя",
            enterName: "Пожалуйста, введите Ваше имя",
            city: "город",
            enterCity: "Пожалуйста, введите ваш город",
            IDNumber: "идентификационный номер",
            enterIDNumber: "Пожалуйста, введите свой идентификационный номер",
        },
        noAdvancedAuthentication: {
            title: "Расширенная сертификация",
            infoCountry: "страна/регион",
            infoName: "Имя",
            infoNumber: "идентификационный номер",
            infoAddress: "адрес",
        },
        text: "не сертифицирован",
        recertification: "ресертификация",
        certification: "Сертификация",
        authenticationInProgress: "проверено",
        inAuthentication: "Сертификация в процессе",
        uploadTheFrontOfTheDocument: "Загрузите лицевую часть удостоверения личности",
        uploadTheReverseSideOfTheDocument: "Загрузите обратную сторону сертификата",
        uploadAPhotoOfAHandHeldID: "Загрузите фотографию своего удостоверения личности на руке",
        pleaseUpload: "пожалуйста ",
        pleaseCompleteOrdinaryCertificationFirst: "Необходимо дождаться успеха первичной сертификационной проверки",
        refused: "отклоненный",
        reason: "причина",
        succeeded: "удалось",
        uploading: "загрузка",
        newTitle: "Выберите страну, в которой было выдано ваше удостоверение личности",
        pleaseOrdinaryCertificationFirst: "Пожалуйста, сначала проведите первичную сертификацию",
        text1: "Изменить аватар",
        text2: "Никнейм",
        text3: "счет",
        text4: "Изменение ника",
        text5: "новый псевдоним",
        text6: "Введите свой новый никнейм",
        text7: "Старый пароль",
        text8: "Введите свой старый пароль",
        text9: "Новый пароль",
        text10: "Введите новый пароль",
        text11: "Подтвердите пароль",

        text12: "Введите новый пароль еще раз",
        text13: "новый почтовый ящик",
        text14: "Проверочный код",
        text15: "пожалуйста, введите код подтверждения",
        text16: "номер вашего мобильного телефона",
        text17: "Новый номер мобильного телефона",
        text18: "Пожалуйста, введите свой номер телефона",
        text19: "Код подтверждения мобильного телефона",
        text20: "Младшая сертификация",
        text21: "Пожалуйста, подтвердите свою идентификационную информацию",
        text22: "Страна",
        text23: "Город",
        text24: "Введите свой город",
        text25: "Введите ваше имя",
        text26: "Ваш идентификационный номер",
        text27: "Введите свой идентификационный номер",
        text28: "Фото на лицевой стороне удостоверения личности",
        text29: "Нажмите, чтобы загрузить ваши документы",
        text30: "повторно загрузить",
        text31: "загрузить",
        text32: "Держу удостоверение личности с фотографией",
        text33: "Нажмите, чтобы загрузить фотографию своего удостоверения личности",
        text34: "Вы привязали Google Authenticator",
        text35: "ключ",
        text36: "Пожалуйста, введите код подтверждения Google",
        text37: "отправлять",
        text38: "Не может быть пустым",
        text39: "Формат электронной почты неправильный",
        text40: "Два пароля несовместимы",
        text41: "Скопировано успешно",
        text42: "Не удалось скопировать",
        text43: "Модификация аватара",
        text44: "изменить пароль",
        text45: "Привязка электронной почты",
        text46: "Изменить адрес электронной почты",
        text47: "Привязка мобильного телефона",
        text48: "Изменить мобильный телефон",
        text49: "Google-проверка",
        text50: "Привязать Google Authenticator",
        text51: "Введите код подтверждения Google",
        text52: "сохранять",
        text53: "Подтвердить отправку",
        text54: "Исправлять",
        text55: "обязательность",
        text56: "Отключить проверку Google",
        text57: "Следующий шаг",
        text58: "Заканчивать",
        text59: "Проверка Google привязана",
        text60: "Проверка Google была разделена",
        text61: "Первичная сертификация сдана",
        text62: "Продвинутая сертификация отправлена",
        text63: "Изображение не загружено",
        text64: "Отправить",
        text65: "Пожалуйста, введите псевдоним",
        text66: "Псевдоним успешно сохранен",
        text67: "Изображения пока не загружены",
        text68: "Сброс пароля завершен",
        text69: "Электронная почта успешно изменена",
        text70: "Аватар успешно сохранен",
        text71: "Загрузить изображение",
        text72: "твой почтовый ящик",
        text73: "Введите новый адрес электронной почты",
        text74: "Ваше имя",
        text75: "Перейти к аутентификации",
        text76: "Пожалуйста, подтвердите свою фотографию, удостоверяющую личность"
    },
    retrievePassword: {
        formTitle1: "Сброс пароля",
        formTitle2: "В целях безопасности ваших активов транзакции запрещены в течение 24 часов после смены пароля.",
        formTitle3: "Получить пароль",
        formTitle4: "Подтвердите изменения",
        formTitle5: "Пожалуйста, введите старый пароль",
        formTitle6: "Пожалуйста, введите новый пароль"
    },
    home: {
        title1: "Самая популярная платформа для торговли криптовалютой",
        title3: "почему ",
        title4: " Это высокопроизводительная блокчейн-платформа с открытым исходным кодом, предназначенная для поддержки и эксплуатации безопасной, совместимой и предсказуемой цифровой инфраструктуры.",
        field1: "Установленная биржа",
        field2: "Финансовые услуги цифровых активов",
        field3: "Десятки миллионов пользователей",
        field4: "Создание нескольких фондов защиты инвесторов",
        field5: "Быстрая торговля",
        field6: "CME Gruop может сопоставлять заказы со сверхнизкой задержкой, обеспечивая максимальный опыт торговли.",
        title5: "рыночная тенденция",
        title6: "узнать больше",
        table1: "Валюта",
        table2: "Последняя цена",
        table3: "24 часа взлетов и падений",
        table4: "Объем торгов за 24 часа",
        table5: "Объем транзакций за 24 часа",
        table6: "Кавычки",
        title7: "о ",
        title8: " Мы стремимся предоставить пользователям самые передовые торговые инструменты, инновационные технологии и беспрецедентное качество обслуживания клиентов.",
        title9: "Область цифровых активов меняется с каждым днём. Только проявив дальновидность и добиваясь быстрого прогресса, мы можем идти в ногу с темпами технологических инноваций.",
        title901: " Предоставление самых передовых услуг по торговле цифровыми активами нашим пользователям и глобальным поставщикам ликвидности.",
        title10: "Мы твердо верим, что каждый пользователь заслуживает лучшего опыта торговли.",
        title11: "Безопасность, которой можно доверять",
        title12: "Наши сложные меры безопасности и фонды SAFU защищают ваши цифровые активы от всех рисков. ",
        title13: "Лучшие ставки транзакций",
        title14: "Льготные ставки транзакций, конкурентоспособные VIP-права и услуги самого высокого качества.",
        title15: "Круглосуточная служба поддержки клиентов 24*7 часов",
        title16: "Круглосуточный всепогодный, постоянный режим работы, мы ответим на ваши актуальные запросы в кратчайшие сроки.",
        title17: "0 комиссия за торговлю",
        title18: "Используйте несколько способов оплаты для торговли цифровыми валютами с нулевой комиссией за обработку, безопасно и быстро.",
        title19: "Торгуйте в любое время и в любом месте",
        title20: "Идеально совместим с несколькими терминалами, удовлетворяя потребности транзакций в различных сценариях в любое время.",
        title21: "Проверяйте рыночные условия в режиме реального времени в любое время",
        title22: "Легко покупайте и продавайте BTC, ETH, XRP и другие цифровые активы.",
        title23: "Получайте ранние предупреждения об изменении цен на интересующие вас криптовалюты.",
        title24: "Просмотр спотового кредита на биткойны, фьючерсного кредита и цен опционов",
        title25: "Сравните цены на криптовалюту на различных биржах",
        title26: "Войти Сейчас",
        title27: "Доллар",
        title28: "Объем торгов за 24 часа",
        title29: "Интегрированный поставщик ликвидности",
        title30: "пользователь",
        title31: "Более",
        title32: "Binance Loan добавляет CTSI и KSM в качестве залоговых активов и запускает скидки на снижение процентных ставок по BUSD и USDT!",
        title33: "Наше преимущество",
        title34: "безопасный и стабильный",
        title35: "Ведущая техническая группа самостоятельно разрабатывает высокоскоростной механизм синтеза транзакций, который по-прежнему может стабильно и надежно работать при массовых одновременных транзакциях.",
        title36: "Профессиональное соответствие",
        title37: "Профессиональная операционная команда, имеющая многолетний опыт работы в сфере блокчейна и финансов, имеет соответствующую лицензию на торговлю цифровыми активами и 100% гарантию резерва.",
        title38: "Сначала пользователь",
        title39: "Выход на глобальный рынок, поддержка нескольких языков, круглосуточная работа, мощная поддержка сообщества и профессиональное обслуживание клиентов.",
        title40: "высокая производительность",
        title41: "300 000 транзакций в секунду и время ответа на заказ менее 1 миллисекунды.",
        title42: "о нас",
        title43: "Торгуйте в любое время и в любом месте",
        title44: "Идеально совместим с несколькими терминалами, удовлетворяя потребности транзакций в различных сценариях в любое время.",
        title45: "（Сканируйте код для загрузки）",
        title46: "Новости цифровой валюты",
        title47: "наш деловой партнер",
        title48: "Список проигравших",
        title49: "24-часовой оборот",
        title50: "24 часа увеличения и уменьшения"
    },
    quotation: {
        marketTrading: "Кавычки",
        turnover: "Объем",
        optional: "Необязательный",
        contractMarket: "контрактный рынок",
        currencyPair: "валютная пара",
        latestPrice: "Цена закрытия",
        upsAndDowns: "Изменение котировки",
        highest: "Наибольший",
        lowest: "самый низкий",
        transactionAmount: "Объем транзакции",
        operate: "действовать",
        buy: "торговля",
        topTurnovers: "Список транзакций",
        topGainers: "Список гейнеров",
        tradingPair: "торговая пара",
        buyOrder: "Купить",
        sellOrder: "ордер на продажу"
    },
    accountChange: {
        demo: "моделирование",
        realAccount: "фактический счет",
        demoAccount: "Демо-счет",
        accountRole: "Роль аккаунта",
        pleaseSelect: "пожалуйста, выбери",
        AccountChangeType: "Тип изменения аккаунта",
        AccountType: "тип аккаунта",
        currencyType: "Тип валюты",
        allType: "Все типы",
        allAccount: "Все аккаунты",
        allCoin: "Все валюты",
        coin: "Валюта",
        amount: "Изменить сумму",
        balance: "Баланс",
        time: "время",
        title: "Записи об изменении учетной записи",
        filtrar: "фильтр",
        check: "переключить на",
        showOnly: "Отображать только валютные запасы",
        holdAssets: "Валютный баланс",
        accountList: "Список аккаунтов"
    },
    contractTransaction: {
        chart: "диаграмма",
        basicEdition: "Базовая версия",
        depthMap: "Карта глубины",
        second: "Второй",
        minute: "точка",
        day: "небо",
        week: "неделя",
        month: "луна",
        open: "открыть",
        trade: "торговля",
        buyLong: "долго покупать",
        buyShort: "короткая покупка",
        cannotBuy: "Эта валюта не поддерживает транзакции по контракту на поставку.",
        cannotBuy1: "Эта валюта не поддерживает бессрочную торговлю",
        tradingAssets: "торговые активы",
        amountAvailable: "Кол-во в наличии",
        timeStr: "время",
        transactionPeriod: "торговый период",
        quantity: "количество",
        enterQuantity: "Пожалуйста, введите количество",
        buyIn: "Идти долго",
        latestTransaction: "последняя транзакция",
        time: "время",
        direction: "направление",
        price: "цена",
        sell: "короткий",
        positionOrder: "Доставка заказа",
        historicalOrders: "Исторические порядки",
        product: "продукт",
        realAccount: "(реальный счет)",
        demoAccount: "(Демо-счет)",
        openingTime: "время заказа",
        openingPrice: "Цена открытия",
        curretPrice: "Текущая цена",
        liquidationPrice: "Цена закрытия",
        profitOrLoss: "Доходы и расходы",
        endTime: "Время закрытия",
        areYouSureToBuy: "Вы уверены, что хотите купить?",
        areYouSureToLongBuy: "Вы уверены, что хотите пойти на длинную позицию?",
        areYouSureToShortBuy: "Вы уверены, что хотите покупать короткие позиции?",
        successfullyBought: "Купить успешно",
        minBuy: "Минимальный бай-ин",
        assets: "ресурсы",
        withdraw: "отзывать",
        entrustedOrder: "Заказ",
        total: "общий",
        continueToPlaceOrder: "Продолжить оформление заказа",
        orderConfirmation: "Подтверждение заказа",
        buyRu: "купить",
        sellChu: "продавать",
        areYouSureToSell: "Вы уверены, что хотите продать?",
        operation: "действовать",
        buyCover: "позиция прикрытия",
        commitSuccess: "Транзакция успешна",
        onlyEnterIntegers: "Можно вводить только целые числа",
        trend: "Тренд",
        lotteryTime: "Крайний срок заказа",
        countdown: "Обратный отсчет",
        period: "Проблема",
        cycle: "Временной период",
        unlimited: "Безлимитный",
        put: "PUT",
        call: "CALL",
        pending: "На комиссию",
        unopened: "Еще не нарисовано",
        opened: "Приз разыгран",
        settlementPrice: "Расчетная цена",
        rateOfReturn: "норма прибыли",
        currentPositions: "Текущая позиция",
        positionQuantity: "Количество позиций",
        guarantee: "допуск",
        text1: "Рост",
        text2: "Снижение",
        text3: "Ожидание покупки",
        text4: "Заказанное Количество",
        text5: "Количество транзакций",
        text6: "Отмена",
        text7: "срок поставки",
        text8: "Напоминание об отмене",
        text9: "Вы уверены, что хотите отменить заказ?",
        text10: "Недопустимое количество",
        text11: "Напоминание о заказе",
        text12: "Вы уверены, что покупаете бычьи позиции?",
        text13: "Вы уверены, что покупаете пут?",
        text14: "Отмена прошла успешно"
    },
    mining: {
        title1: "Ведущая в мире платформа для майнинга цифровых активов на блокчейне",
        title2: "Открыто и прозрачно · безопасно и стабильно",
        title3: "Пожалуйста, выберите валюту",
        title4: "Годовая доходность горнодобывающей промышленности",
        title5: "небо",
        title6: "Период майнинга",
        title7: "информация о продукте",
        btn: "Мой сейчас",
        btn2: "закрытие",
        tabs1: "в ходе выполнения",
        tabs2: "искуплен",
        table1: "наименование товара",
        table2: "Период майнинга",
        table3: "Время майнинга",
        table4: "Сумма майнинга",
        table5: "Годен до",
        table6: "Поступления к погашению",
        table7: "Статус заказа",
        egularMining: "Майнинг регулярно",
        inProgress: "в ходе выполнения",
        redeemed: "искуплен",
        redemption: "искупление",
        regularMining: "Майнинг регулярно",
        earlyRedemption: "досрочное погашение",
        need: "нуждаться",
        handlingFee: "плата за обработку",
        redemptionConfirmationMessage: "Пожалуйста, подтвердите, нужно ли выкупать заранее?",
        form1: "Годовая доходность горнодобывающей промышленности",
        form2: "Период майнинга",
        form3: "Майнинг валюты",
        form4: "Сумма подписки (минимум/максимум)",
        form5: "Плата за досрочное погашение: ",
        form6: "закупочная цена",
        form7: "Доступные средства",
        form8: "закупочная цена",
        form9: "Доступные средства",
        form10: "Пожалуйста, введите сумму покупки",
        form11: "все",
        form12: "Предполагаемый доход",
        form13: "Недостаточно средств",
        form14: "Пожалуйста, введите сумму покупки",
        form15: "Мой заказ",
        form16: "доход",
        form17: "Информация для заказа",
        form18: "Инструкция по досрочному погашению:",
        form19: "Сумма подписки (минимум)",
        form20: "Сумма подписки (максимум)",
        form21: "Количество удерживаемых",
        form22: "Покупка времени",
        form23: "время выкупа",
        form24: "над",
        form25: "Подписка прошла успешно",
        form26: "Погашение успешно",
        form27: "Простое управление финансами с доходностью более 25%, превосходящей рынок, а также вы можете получать вознаграждения после покупки.",
        form28: "Пригласите друзей, чтобы получить вознаграждение в размере 50 долларов США, а ваучеры контракта также могут вернуть 20% комиссии."
    },
    assets: {
        content1: "Активы аккаунта",
        content2: "Сегодняшний доход",
        content3: "текущий аккаунт",
        content4: "Фактический счет — это фактические активы вашего счета, которые можно использовать для транзакций и снятия средств.",
        content5: "Вывод монет",
        content6: "Депозитные монеты",
        content7: "обмен",
        content8: "передача",
        content9: "пожалуйста, выбери",
        content10: "Демо-счет",
        content11: "фактический счет",
        content12: "приобретать активы",
        content13: "Вы уверены, что хотите перейти на реальный аккаунт?",
        content14: "Вы уверены, что хотите переключиться на демо-счет?",
        content15: "добиться успеха",
        table1: "Валюта",
        table2: "количество",
        table3: "заморозить",
        table4: "Доступный",
        dialog1: "информация о продукте",
        dialog2: "1. Этот актив разрешено использовать только в режиме демо-счета.",
        dialog3: "2. Во избежание злоупотреблений разрешено только одно погашение в течение месяца.",
        dialog4: "3. При поступлении активов сумма полученных активов будет добавлена ​​к первоначальной сумме и статус позиции не изменится.",
        dialog5: "4. Если у вас есть какие-либо другие вопросы, пожалуйста, свяжитесь со службой поддержки клиентов.",
        dialog6: "закрытие",
        dialog7: "Флеш",
        dialog8: "перевод в",
        dialog9: "переводить",
        dialog10: "выключатель",
        dialog11: "Оценка",
        dialog12: "Демо-активы",
        dialog13: "мой счет",
        dialog14: "Общая сумма активов аккаунта",
        dialog15: "Обзор активов",
        dialog16: "Общая оценка активов",
        dialog17: "Оценка активов",
        dialog18: "Сегодняшний доход",
        dialog19: "заморозить средства",
        dialog20: "Получайте моделируемые активы каждый месяц",
        dialog21: "получать",
        dialog22: "Вы успешно получили",
        dialog23: 'Совокупный доход за 30 дней',
        dialog24: "Финансовый продукт",
        dialog25: "Мой финансовый менеджмент",
        dialog26: "Исторический финансовый менеджмент",
        dialog27: "запись истории",
        dialog28: "Отчеты о финансировании"
    },
    validator: {
        dialog14: "валидатор",
        dialog15: "Привязать валидатор",
        dialog16: "переключатель валидатора",
        dialog17: "Проверочный код",
        dialog18: "QR-код валидатора",
        dialog19: "ключ валидатора",
        dialog20: "сохранять",
        dialog21: "Пожалуйста, выберите валидатор",
        dialog22: "копировать ключ",
        dialog23: "Успешно сохранено",
        dialog24: "пожалуйста, введите код подтверждения",
        dialog25: "Дружеское напоминание: прежде чем подтвердить сохранение, откройте соответствующее приложение и отсканируйте QR-код ниже или добавьте ключ вручную!",
        dialog26: "Включение аутентификатора обеспечивает максимальную безопасность вашей учетной записи.",
        dialog27: "Вам нужно будет вводить уникальный код подтверждения, доступный через ваш мобильный телефон, каждый раз, когда вы входите в систему или снимаете деньги.",
        dialog28: "Настроить валидатор",
        dialog29: "помощь",
        dialog30: "Вы не привязали код аутентификации. Получите более надежную защиту с помощью аутентификатора.",
        dialog31: "Валидатор еще не настроен, пожалуйста, сначала настройте его.",
        dialog32: "Перейдите в настройки"
    },
    recharge: {
        title1: "Не знаете, как совершать покупки с помощью цифровой валюты?",
        title2: "Всего три простых шага!",
        title3: "Выберите цифровую валюту, которую вы хотите приобрести, из раскрывающегося меню и введите количество или сумму покупки.",
        title4: "Выберите предпочтительный способ оплаты",
        title5: "После подтверждения оплаты приобретенная вами цифровая валюта будет автоматически переведена на ваш счет.",
        title6: "Пожалуйста, выберите валюту, которую вы хотите пополнить",
        title7: "Депозитная запись",
        table1: "Валюта",
        table2: "количество",
        table3: "Название сети",
        table4: "состояние",
        table5: "причина",
        table6: "время",
        table7: "Посмотреть ваучер",
        dialog1: "Пожалуйста, введите код подтверждения ниже",
        dialog2: "код платежа",
        dialog3: "копировать",
        dialog4: "адрес",
        dialog5: "Сумма вклада",
        dialog6: "Скриншот транзакции",
        dialog7: "важное замечание",
        dialog8: "Пожалуйста, укажите сумму депозита",
        dialog9: "загрузить изображение",
        dialog10: "Пожалуйста, введите содержание",
        dialog11: "Выложите пожалуйста скриншоты пополнения",
        dialog12: "Не проверено",
        dialog13: "отклоненный",
        dialog14: "Депонированный",
        tip1: "Отправлено успешно",
        tip2: "Скопировано успешно",
        tip3: "Не удалось скопировать",
        tip4: "Пожалуйста, выберите валюту, которую вы хотите пополнить",
        tip5: "1.Вышеупомянутый адрес депозита является официальным платежным адресом платформы. Найдите официальный адрес депозита платформы. Вы будете нести ответственность за потерю средств, вызванную ошибочным депозитом;",
        tip6: "2.Обязательно убедитесь в безопасности вашего компьютера и браузера, чтобы предотвратить подделку или утечку информации;",
        tip7: "3.После того, как вы пополните указанный выше адрес, весь сетевой узел должен подтвердить это, прежде чем счет можно будет пополнить;",
        tip8: "4.Пожалуйста, выберите вышеуказанную систему токенов и валюту и переведите соответствующую сумму на депозит. Пожалуйста, не переводите какие-либо другие несвязанные активы, иначе они не будут получены.",
        tip9: "Сохранить QR-код",
        tip10: "пополнить",
        tip11: "важное замечание",
        tip12: "Внешние ссылки",
        tip13: "QR-код пополнения счета",
        tip14: "Следующий шаг",
        tip15: "Запись пополнения счета",
        tip16: "Запись пополнения счетаПодробнее о пополнении счета",
        tip17: "Адрес депозита",
        tip18: "Быстрая оплата",
        tip20: "Недостаточный баланс",
        tip22: "Отправлено, ждем подтверждения",
        tip23: "ожидается платеж",
        tip24: "Количество",
        tip25: "Платеж отправлен, ждём подтверждения блокировки",
        tip26: "Платеж отклонен",
        tip27: "Ошибка оплаты",
        tip28: "Платеж успешен",
        bankChannel: "Канал банковских карт",
        tip29: "Исторические поиски",
        tip30: "Список валют",
        tip31: "Выберите сеть",
        tip32: "При пополнении счета в этой валюте пополняйте баланс только через указанные ниже поддерживаемые сети. Если вы пополните счет через другие сети, средства будут потеряны.",
        tip33: "При выводе средств в этой валюте используйте только указанные ниже поддерживаемые сети. Если вы выводите средства через другие сети, средства будут потеряны.",
        tip34: "Быстрая перезарядка",
        tip35: "Сканируйте код для пополнения баланса",
        tip36: "Ручная перезарядка",
        tip37: "Пополнить сеть",

        tip38: "Адрес пополнения счета",
        tip39: "Сумма пополнения",
        tip40: "Загрузка квитанции о транзакции",
        tip41: "загрузить изображение",
        tip42: "подтвердить отправку",
        tip43: "подтвердить оплату",
        tip44: "Примечание. Пожалуйста, подтвердите адрес, который вам нужно пополнить. Мы не несем ответственности за потерю денег, если вы заполните его неправильно.",
        tip45: "напоминать",
        tip46: "Адрес успешно скопирован!",
        tip47: "Копирование адреса не удалось!",
        tip48: "Недостаточно доступного баланса",
        tip49: "Пополнение баланса успешно отправлено и ожидает подтверждения в цепочке.",
        tip50: "Пополнение не удалось",
        tip51: "Сумма пополнения указана неверно.",
        tip52: "Соединение не удалось",
        tip53: "Кошелек не авторизован",
        tip54: "В соединении отказано",
        tip55: "Отправлено успешно. Ожидается проверка и одобрение службы поддержки клиентов.",
        tip56: "Пожалуйста, загрузите скриншот квитанции о транзакции",
        tip57: "Отправка не удалась",
        tip58: "Запись пополнения счета",
        tip59: "Запись о снятии средств",
        tip60: "Пополнить валюту",
        tip61: "Валюта вывода",
        tip62: "Адрес пополнения счета",
        tip63: "Скриншот показывает",
        tip64: "Нажмите увеличить",
        tip65: "Время перезарядки",
        tip66: "Причина отказа",
        tip67: "Сумма вывода",
        tip68: "Полученная сумма",
        tip69: "Сеть вывода наличных",
        tip70: "Адрес вывода",
        tip71: "Время вывода",
        tip72: "закрытие",
        tip73: "Скриншот транзакции",
        tip74: "Ожидает",
        tip75: "отклоненный",
        tip76: "завершенный",
        tip77: "отклоненный",
        tip78: "Проверено",
        tip79: "Выплачено",
        tip80: "извлекать",
        tip81: "сеть передачи",
        tip82: "Адрес/Счет",
        tip83: "Вывести все",
        tip84: "Пожалуйста, не выводите деньги непосредственно на адрес краудфандинга или ICO, иначе вы не сможете получить токены, выпущенные краудфандингом или ICO.",
        tip85: "Количество прибытия",
        tip86: "Подтвердить вывод",
        tip87: "Неправильный адрес вывода",
        tip88: "Неверная сумма вывода",
        tip89: "Сумма вывода не менее",
        tip90: "Максимальная сумма вывода составляет",
        tip91: "Запрос на вывод средств отправлен",
        tip92: "список адресов",
        tip93: "Вы еще не добавили адрес",
        tip94: "Добавьте это сейчас",
        tip95: "Добавить адрес",
        tip96: "Добавить новый адрес",
        tip97: "пожалуйста, выбери",
        tip98: "адрес",
        tip99: "Пожалуйста, выберите сеть передачи",
        tip100: "Пожалуйста, введите адрес",
        tip101: "Адрес успешно добавлен",
        tip102: "в транзакции",
    },
    fundExchange: {
        title1: "Как обменять средства?",
        title2: "Выберите подходящую валюту для конвертации.",
        title3: "Выберите подходящую валюту для конвертации.",
        title4: "Введите сумму для обмена и нажмите «Отправить», чтобы завершить обмен средств.",
        title5: "от",
        title6: "прибыть",
        title7: "Количество обмена",
        title8: "обменный курс",
        title9: "Доступный",
        title10: "Пожалуйста, введите сумму погашения",
        title11: "Соответствующей торговой пары для обмена нет.",
        title12: "Пожалуйста, введите сумму, которую нужно выкупить",
        title13: "Погашение успешно",
        title14: "Запись обмена",
        table1: "Использовать валюту",
        table2: "количество",
        table3: "обменный курс",
        table4: "Обмен валют",
        table5: "Квитанция",
        table6: "время",
        title15: "от",
        title16: "В настоящее время нет доступных объектов, пожалуйста, выберите другой"
    },
    fundTransfer: {
        title1: "Как перевести средства?",
        title2: "Выберите текущий аккаунт, который необходимо перенести.",
        title3: "Выберите учетную запись, которую хотите перенести.",
        title4: "Введите сумму перевода и нажмите «Отправить», чтобы завершить перевод.",
        title5: "Валюта",
        title6: "Сумма перевода",
        title7: "Пожалуйста, введите сумму для перевода",
        title8: "запись о передаче",
        title9: "Пожалуйста, выберите тип кошелька",
        title10: "Пожалуйста, выберите валюту",
        title11: "Пожалуйста, выберите тип кошелька",
        title12: "Пожалуйста, выберите валюту",
        title13: "Пожалуйста, введите сумму для перевода",
        title14: "Отправлено успешно",
        table1: "Перевести счет",
        table2: "переводить валюту",
        table3: "Сумма перевода",
        table4: "переводной счет",
        table5: "время",
        table6: "передача",
        table7: "Перевод денежных средств",
        table8: "Перевести",
        table9: "запись о передаче",
        table10: "Детали трансфера",
        table11: "Перенос успешен",
        table12: "Передача не удалась",
        table13: "Текущий счет не может быть перенесен"
    },
    withdrawal: {
        title1: "важное замечание",
        title2: "1.Чтобы предотвратить арбитраж, вы можете подать заявку на вывод валюты, когда объем транзакции достигнет квоты.",
        title3: "2.Заявка на вывод средств будет зачислена в течение 24 часов после подачи. Если вывод средств не получен по истечении расчетного времени вывода, обратитесь в онлайн-службу поддержки клиентов.",
        title4: "3.После подачи заявки на вывод средства находятся в замороженном состоянии, поскольку вывод продолжается и средства временно удерживаются системой. Это не означает, что вы потеряли актив или что с активом возникла неисправность.",
        title5: "Валюта",
        title6: "адрес кошелька",
        title7: "Сумма выведенных монет",
        title8: "Запись о снятии монет",
        title9: "Пожалуйста, выберите валюту",
        title10: "Пожалуйста, выберите тип цепи",
        title101: "",
        title11: "Пожалуйста входите",
        title12: "адрес кошелька",
        title13: "Отправлено успешно",
        title14: "на рассмотрении",
        title15: "Проверка прошла успешно",
        title16: "Ошибка аудита",
        title17: "Выплачено",
        title18: "Пожалуйста, введите или вставьте адрес вашего кошелька",
        title19: "Пожалуйста, введите сумму вывода",
        title20: "плата за обработку",
        title21: "Фактическое прибытие",
        table1: "Валюта",
        table2: "Сумма выведенных монет",
        table3: "Название сети",
        table4: "адрес кошелька",
        table5: "состояние",
        table6: "причина",
        table7: "время подачи заявки",
        table8: "Вывод монет",
        table81: "Вывод монет",
        table9: "Адрес вывода",
        table10: "Пожалуйста, выберите валюту, которую вы хотите вывести",
        table11: "Пожалуйста, убедитесь, что вы входите",
        table12: "Адрес (обычно начинается с «0x»)",
        table13: "Выводимые монеты (за вычетом комиссии за обработку)：",
        table14: "Выберите валюту",
        table15: "Столкнулись с проблемами? Немедленная обратная связь",
        table16: "баланс",
        table17: "Детали вывода средств",
        password: "пароль",
        passwordTips: "Пожалуйста введите пароль",
        passwordAg: "Подтвердите пароль",
        passwordAgTips: "Пожалуйста, введите пароль еще раз",
        oldPassword: "Старый пароль",
        oldPasswordTips: "Пожалуйста, введите старый пароль",
        newPassword: "Новый пароль",
        newPasswordTips: "Пожалуйста, введите новый пароль",
        passwordNotSame: "Пароли несовместимы",
        withdrawPasswordSet: "Установить пароль для вывода",
        withdrawPasswordModify: "Изменить пароль для вывода",
        withdrawPassword: "Снять пароль",
        withdrawPasswordTips: "Пожалуйста, введите пароль для вывода средств",
        setWithdrawPasswordFirst: "Пожалуйста, сначала установите пароль для вывода средств",
        withdrawPasswordSetSuccess: "Установка прошла успешно",
        withdrawPasswordModifySuccess: "Успешно изменено",
        submit: "представлять на рассмотрение",
    },
    customer: {
        content1: "Интернет Сервис",
        content2: "обслуживание клиентов",
        content3: "Пожалуйста, введите вашу контактную информацию",
        content4: "Пожалуйста, введите содержание",
        content5: "отправлять",
        content6: "Не удалось отправить, не удалось подключиться к сети",
        content7: "картина",
        content8: "сообщение пусто",
        content9: "моя доля",
        content10: "Поделиться ссылкой",
        content11: "сохранить изображение",
        content12: "мой заработок",
        content13: "Описание уровня",
        content14: "Размер команды",
        content15: "Доход от приглашения",
        content16: "делиться",
        content17: "уровень членства",
        content18: "Сумма пополнения превышает",
        content19: "Уровень команды",
        content20: "Уровень команды и доход",
        content21: "Чтобы выполнить условия",
        content22: "Доход от распределения",
        content23: "команда уровня",
        content24: "уровень, приглашение",
        content25: "действительные члены",
        content26: "основной доход",
        content27: "вторичный доход",
        content28: "Доход 3 уровня",
    },
    standardContract: {
        increaseMargin: "Увеличивать",
        increaseAmount: "увеличить сумму",
        Pleaseenterthemargin: "Пожалуйста, введите сумму маржи",
        Pleaseenterthecorrect: "Пожалуйста, введите правильную сумму депозита",
        Increasemarginsuccessfully: "Успешно увеличить маржу",
        takeProfitPriceWrong: "Неправильная цена тейк-профита",
        stoppriceerror: "Ошибка стоп-цены",
        thetakeprofit1: "Цена тейк-профита должна быть выше рыночной цены.",
        thetakeprofit2: "Цена стоп-лосса должна быть ниже рыночной цены.",
        thetakeprofit3: "Цена тейк-профита должна быть ниже рыночной цены.",
        thetakeprofit4: "Цена стоп-лосса должна быть выше рыночной цены.",
        thetakeprofit5: "Неправильное количество",
        estimatedprofitloss: "Предполагаемая прибыль и убыток",
        positionAmount: "Количество позиций",
        closeAmount: "Закрытие количества",
        whenthelatest: "Когда будет достигнута последняя цена",
        whenthelatest2: ", ордер фиксации прибыли по рыночной цене будет активирован для закрытия текущей позиции. Ожидаемая прибыль и убыток",
        whenthelatest3: ", рыночный стоп-лосс будет активирован для закрытия текущей позиции. Ожидаемая прибыль и убыток",
        contract: "договор",
        ordercanceledsuccessfully: "Заказ успешно отменен",
        successfullyordered: "успешно заказан",
        positionopeningreminder: "Напоминание об открытии позиции",
        wrongquantity: "Неправильное количество",
        quantitycannot: "Количество не может быть больше",
        modificationstoploss: "Модификация стоп-профита и стоп-лосса прошла успешно.",
        positionclosedsuccessfully: "Позиция успешно закрыта",
        orderCancellation: "Аннулирование заказа",
        orderCancellation2: "Вы уверены, что хотите отменить заказ?",
        tobeexecuted: "Быть казненным",
        expired: "истекший",
        failed: "неуспешный",
        contractTransaction: "Бессрочный контракт",
        increase: "Увеличивать",
        openPosition: "Полный склад",
        isolatedPosition: "Изолированное положение",
        limitOrder: "ценовой предел",
        marketOrder: "рыночная цена",
        pleaseSelectLeverage: "Пожалуйста, выберите кредитное плечо",
        pleaseEnterQuantity: "Пожалуйста, введите количество",
        canOpenMore: "Максимальная позиция, которую можно открыть",
        contractAmount: "Сумма контракта",
        openingFee: "плата за обработку",
        currentPosition: "Позиция",
        historicalPositions: "Исторические транзакции",
        currentCommission: "Текущий заказ",
        historicalCommission: "историческая комиссия",
        buyPrice: "цена покупки",
        income: "выгода",
        quantity: "количество",
        marginRate: "ставка маржи",
        initialMargin: "Начальная маржа",
        estimatedPriceParity: "Цена принудительной ликвидации",
        operate: "действовать",
        finishQuantity: "Объем транзакции",
        averagePrice: "средняя цена сделки",
        pleaseEnterLeverage: "Пожалуйста, введите кредитное плечо",
        takeProfitAndStopLoss: "TP&SL",
        takeProfit: "Тейк-профит",
        stopLoss: "остановить потери",
        openLong: "Long",
        openShort: "Short",
        liquidation: "плоский",
        marketLquidation: "Рыночная цена фиксирована",
        cancel: "Отменить заказ",
        enterBuyPrice: "Пожалуйста, введите цену покупки",
        areYouSureLquidation: "Вы уверены, что закроете позицию?",
        confirm: "Конечно",
        enterStopWinPrice: "Пожалуйста, введите цену тейк-профита",
        enterStopLossPrice: "Пожалуйста, введите цену стоп-лосса",
        commissionTime: "Время комиссии",
        commissionPrice: "Цена комиссии",
        commissionQuantity: "Общая сумма комиссий",
        volumeAlreadyTraded: "Сумма завершена",
        areYouSureToWinOrLoss: "Вы уверены, что хотите остановить прибыль и стоп-лосс?",
        maxQuantity: "Максимальное положение",
        saleQuantity: "Закрытая позиция",
        salePrice: "средняя цена закрытия",
        saleTime: "время",
        succeeded: "удалось",
        cancelled: "Отменено",
        piece: "открыть",
        triggerPrice: "триггерная цена",
        setWin: "Установить тейк-профит",
        setLoss: "Установить стоп-лосс",
        enterWinQuantity: "Пожалуйста, введите сумму тейк-профита",
        enterLossQuantity: "Пожалуйста, введите сумму стоп-лосса",
        planCommission: "Плановая комиссия",
        enterWinTriggerPrice: "Пожалуйста, введите триггерную цену тейк-профита",
        enterLossTriggerPrice: "Пожалуйста, введите цену срабатывания стоп-лосса",
        insufficientQuantity: "Недостаточное количество",
        enterTriggerPrice: "Пожалуйста, введите триггерную цену",
        tips1: "Цена вашего ордера выше текущей цены, и он будет исполнен непосредственно по текущей рыночной цене. Вы уверены, что хотите купить?",
        tips2: "Цена вашего ордера ниже текущей цены, и он будет исполнен непосредственно по текущей рыночной цене. Вы уверены, что покупаете?",
        type: "тип",
        increaseQuantity: "Увеличить позицию",
        reduceQuantity: "Сокращение позиций",
        limitCommission: "лимитный ордер",
        tips3: "Цена стоп-лосса должна быть ниже рыночной цены.",
        tips4: "Цена тейк-профита должна быть выше рыночной цены.",
        tips5: "Цена стоп-лосса должна быть выше рыночной цены.",
        tips6: "Цена тейк-профита должна быть ниже рыночной цены.",
        tips7: "Цена стоп-лосса должна быть ниже рыночной цены и ниже цены ордера.",
        tips8: "Цена тейк-профита должна быть больше цены ордера (может быть меньше рыночной цены)",
        tips9: "Цена стоп-лосса должна быть больше рыночной цены и цены ордера.",
        tips10: "Цена тейк-профита должна быть меньше цены ордера (может быть больше рыночной цены)",
        accountEquity: "Баланс",
        unrealizedPL: "нереализованная прибыль или убыток",
        tips11: "Ты уверен, что прав?",
        tips12: "Рыночная цена",
        tips13: "Закрыть все позиции",
        tips14: "Больше не напоминать",
        profitRate: "Закрытие ставки доходности",
        openTime: "Время открытия",
        unwindTime: "Время закрытия",
        dealTime: "Время транзакции",
        amountClose: "Сумма закрытой позиции",
        long: "много",
        short: 'нулевой',
        orderQuantity: "Заказанное Количество",
        entrustedMargin: "доверенная маржа",
    },
    spotGoods: {
        spotGoods: "Флеш-биржа",
        sellPrice: "цена продажи",
        orderRecord: "Запись о погашении флэш-памяти",
        transactionTime: "Время транзакции",
        maxBuy: "доступен для покупки",
        maxSell: "Доступен для продажи",
        purchaseQuantity: "Количество покупок",
        slippage: "проскальзывание",
        convertTips: "Закроем сделку по наиболее выгодной цене с проскальзыванием 0-5%.",
        changePrice: "Текущая биржевая цена",
        consume: "потреблять",
        get: "получать",
        changeTips: "Вы уверены, что хотите погасить?",
        confirm: "Подтвердить погашение"
    },
    news: {
        title: "Центр новостей",
        redMore: "читать далее",
    },
    credit: {
        credit: "кредитный рейтинг",
        creditScore: "Фракция",
        latestEntry: "последняя запись",
        liveUpdate: "В прямом эфире обновление",
        systemEvaluation: "Оценка системы",
        time: "дата",
        name: "имя",
        reason: "причина",
        scoreStory: "Кредитный рейтинг"
    },
    borrowing: {
        borrowing: "заем",
        diversifiedMarket: "Диверсифицированные рынки",
        totalSupply: "Общий объем поставок",
        totalBorrowings: "общая сумма заимствований",
        tips1: "Это общая сумма, которую вы можете занять под залог, вплоть до лимита займа.",
        tips2: "Ваша стабильная процентная ставка останется неизменной в течение всего срока действия вашего кредита. Рекомендуется для долгосрочных поставок и для пользователей, которым нравится предсказуемость.",
        totalSupplys: "общее предложение",
        supplyAPR: "скорость предложения",
        totalBorrowings: "Общий объем заимствований",
        borrowAPR: "ставка заимствования",
        check: "Проверять",
        market: "рынок",
        availableLiquidity: "Доступная ликвидность",
        currencyPrice: "текущая цена валюты",
        supplyAssets: "поставлять активы",
        tips3: "Примечание. Приведенная ниже процентная ставка является фиксированной. После окончания периода поставки основная сумма плюс доход будут возвращены на ваш счет.",
        supplyCycle: "цикл поставок",
        minimumSupply: "минимальный запас",
        supply: "поставлять",
        borrowedAssets: "заемные активы",
        tips4: "Важно знать: чтобы занять деньги, вам необходимо будет предоставить любые залоговые активы или доказательства,",
        tips5: "Пожалуйста, ознакомьтесь с описанием ипотечного актива.",
        repaymentCycle: "цикл погашения",
        BorrowableAmount: "Доступная сумма кредита",
        borrow: "заем",
        accountInformation: "Информация Об Учетной Записи",
        walletBalance: "баланс кошелька",
        canSupply: "Доступный",
        AmountCanBeBorrowed: "Общая доступная сумма кредита",
        borrowedAmount: "Сумма займа",
        remainingAmount: "остаток средств",
        getBorrowednAmount: "Получить кредитный лимит",
        supplyOrder: "заказ на поставку",
        borrowedOrder: "заказ на кредит",
        supplyAmount: "объем поставки",
        expectedProfits: "Ожидаемое возвращение",
        supplyTime: "Время поставки",
        expirationTime: "Годен до",
        borrowingAmount: "Величина займа",
        dueRepayment: "Сумма погашения",
        borrowingTime: "Время выпуска",
        repaymentTime: "Срок погашения",
        repay: "погашение",
        supplyCurrency: "поставка валюты",
        buyNow: "Купить сейчас",
        supplyRecords: "записи поставок",
        borrowRecords: "Кредитные записи",
        completed: "завершенный",
        borrowNow: "Одолжить сейчас",
        borrowCurrency: "Заимствование валюты",
        borrowMin: "самый маленький",
        borrowMax: "максимум",
        borrowRange: "Сумма займа (минимум/максимум)",
        tips6: "Пожалуйста, погасите долг вовремя. В случае просрочки взимается дополнительная ежедневная сумма в размере (основная сумма + проценты).",
        tips7: "Просроченная плата.",
        pleaseEnterBorrowAmount: "Пожалуйста, введите сумму кредита",
        interest: "Интерес",
        tips8: "Вы уверены, что хотите погасить предоплату?",
        borrowChannel: "Заимствование канала",
        tips9: "Давай начнём со знакомства",
        name: "имя",
        lastName: "фамилия",
        birthDate: "Дата рождения",
        tips10: "Еще немного информации, какой у вас адрес?",
        familyAddress: "Домашний адрес (включая номер квартиры)",
        city: "Город",
        country: "нация",
        postalCode: "Почтовый индекс",
        pleaseEnterYourHomeAddress: "Пожалуйста, введите свой домашний адрес",
        tips11: "Расскажите нам о своем финансовом положении",
        tips12: "Возможно, нам придется подтвердить эту информацию позже, поэтому постарайтесь быть максимально точными.",
        yourMonthlyIncome: "ваш ежемесячный доход",
        enterYourMonthlyIncome: "Пожалуйста, введите свой ежемесячный доход",
        extraIncomeOptional: "Дополнительный доход (необязательно)",
        enterExtraIncome: "Пожалуйста, укажите свой дополнительный доход",
        monthlyRentOrMortgagePayment: "Ежемесячная арендная плата или ипотечный платеж",
        enterMonthlyRent: "Пожалуйста, введите ежемесячную арендную плату или ипотечный платеж.",
        tip13: "Сообщите нам, есть ли у вас ипотека",
        tip14: "Если гарантия по ипотеке не выбрана, вероятность прохождения проверки мала.",
        isThereMortgage: "Есть ли ипотека?",
        selectIsThereMortgage: "Пожалуйста, выберите, есть ли ипотека",
        selectMortgageType: "Пожалуйста, выберите тип ипотеки",
        yes: "да",
        no: "нет",
        uploadScreenshotOfTransaction: "Пожалуйста, загрузите скриншоты транзакций",
        tip15: "Будем на связи",
        tip16: "Мы можем связаться с вами по этому номеру, если нам понадобится дополнительная информация о вашей заявке на кредит.",
        tip17: "Я прочитал и подписал электронно свое согласие",
        tip18: "Условия использования и электронное согласие",
        tip19: ", что включает в себя ваше согласие на отправку вам информации о наших",
        tip20: "Условия использования продуктов и услуг",
        tip21: "После заполнения информации дождитесь оценки и проверки системы.",
        phoneNumber: "номер телефона",
        enterPhoneNumber: "Пожалуйста, введите свой номер телефона",
        tip22: "Установите флажок, чтобы согласиться с условиями использования и формой электронного согласия.",
        inReview: "на рассмотрении",
        applicationAmount: "Сумма заявки",
        reasonForRejection: "Причина отказа",
        reapply: "Повторно подать заявку",
        applyStatus: "статус приложения",
        currentOrder: "текущий заказ",
        interestRate: "процентная ставка"
    },
    yuebao: {
        filed1: "вкладывать деньги",
        filed2: "выиграть",
        filed3: "Ежедневный доход",
        filed4: "командное ускорение",
        filed5: "Депонированный",
        filed6: "Вчерашний заработок",
        filed7: "Общий доход",
        filed8: "Доступные средства",
        filed9: "Пожалуйста, введите сумму",
        filed10: "Майнинг ликвидности",
        filed11: "Введение",
        field12: "Минимальная цена покупки",
        field13: "Максимум, что вы можете купить",
        filed14: "Подписка",
        filed15: 'обычный',
        filed16: 'годовая процентная ставка',
    },
    tipsPopover: {
        title: "Установите это приложение",
        press: "в соответствии с",
        and: "и",
        scrren: "Добавить на домашний экран",
        hasInstall: "(Если установлено, закройте окно.)",
    },
    follow: {
        title1: "Последующий план",
        follow_text1: "Инициировать последующий заказ",
        follow_text2: "История выпусков",
        follow_text3: "заголовок",
        follow_text4: 'торговая пара',
        follow_text5: 'Продолжительность покупки',
        follow_text6: 'время заказа',
        follow_text7: 'время выпуска',
        follow_text8: 'Количество подписчиков',
        follow_text9: 'Сумма заказа',
        follow_text10: 'действовать',
        follow_text11: 'приглашать',
        follow_text12: 'Следуйте направлению заказа',
        follow_text13: 'Установить условия заказа',
        follow_text14: 'Условия выполнения заказов',
        follow_text15: 'фиксированное количество',
        follow_text16: 'процент',
        follow_text17: 'Приглашенные люди',
        follow_text18: 'Идентификатор другой стороны',
        follow_text19: "Подтвердите выполнение заказа",
        follow_text20: "Сумма вашего заказа (необязательно)",
        follow_text21: "Пожалуйста, введите название",
        follow_text22: "Пожалуйста, выберите торговую пару",
        follow_text23: "Пожалуйста, выберите направление заказа",
        follow_text24: "Пожалуйста, выберите продолжительность покупки",
        follow_text25: "Пожалуйста, выберите время заказа",
        follow_text26: "Пожалуйста, выберите количество покупки",
        follow_text27: "Максимальный объем покупки не может быть меньше минимального количества покупки.",
        follow_text28: "Минимальный бай-ин",
        follow_text29: "Большинство покупают",
        follow_text30: "Заказ на копирование успешно создан",
        follow_text31: "Список торговых пар",
        follow_text32: "Уже выполнил заказ",
        follow_text33: "Пожалуйста, введите информацию о приглашенном",
        follow_text34: "Приглашен",
        follow_text35: "Пригласи меня",
        follow_text36: "Копирование истории",
        follow_text37: "Диапазон суммы заказа",
        follow_text38:"Введите код заказа"
    },
    followHistory: {
        title1: 'История выпусков',
        title2: "Копирование истории",
        follow_h_text1: "Общая сумма заказа",
        follow_h_text2: "Общее количество людей, выполняющих заказы",
        follow_h_text3: "Количество выпусков",
        follow_h_text4: "процент выигрышей",
        follow_h_text5: "Сколько раз выполнять приказы",
        follow_h_text6: "Прибыль от следующих заказов",
        follow_h_text7: "направление",
        follow_h_text8: "победить",
        follow_h_text9: "дефицит",
    },
    "asset.index.1579E8B41F8D5134": "мои активы",
    "asset.index.B3F6F05Dfbe431Cd": "моделирование",
    "asset.index.B9Aeab4Ee8F33746": "Оценка активов",
    "asset.index.583Df8Bd541Eb7E8": "тенденции доходов",
    "asset.index.B1254815D133Cc26": "7 дней",
    "asset.index.2F615F6C029F01B7": "30 дней",
    "asset.index.29439Fb58E4Bbe22": "отзывать",
    "asset.index.831Ab31568A78285": "пополнить",
    "asset.index.39F7A0D48D12E8C9": "передача",
    "asset.index.B99063C5689Beaec": "Флеш-биржа",
    "asset.index.E1Dc620F2F038B2A": "Получить активы",
    "asset.index.972A0B4C2B4393D0": "мой счет",
    "asset.index.9Dfb0Fb334620733": "доступные средства",
    "asset.index.Cdc5Fbd26790Cb47": "замороженная сумма",
    "asset.index.3D8132D72Ae965Cd": "Оценка",
    "asset.receive.825503Cc430559Cb": "приобретать активы",
    "asset.receive.54154A0553A535B7": "Демо-активы",
    "asset.receive.F2E57B00A9C5D129": "1.Этот актив разрешено использовать только в режиме демо-счета.",
    "asset.receive.Ea0D1D52989299Bd": "2.Во избежание злоупотреблений разрешено только одно погашение в течение месяца.",
    "asset.receive.090E0037Aa235D3D": "3.Получение активов добавит сумму активов, полученных первоначально, и не изменит статус позиции.",
    "asset.receive.7Fd4E1Abc805C0A6": "4.Если у вас есть какие-либо другие вопросы, пожалуйста, свяжитесь со службой поддержки клиентов",
    "asset.receive.Df5B3A511D986575": "Получите демо-ресурсы прямо сейчас",
    "asset.records.1Fa02E8187A39592": "последние три месяца",
    "asset.records.7B291C37333Fe34D": "от близкого к далекому",
    "asset.records.A476Cd1Ec868Fc5F": "последние три месяца,",
    "asset.records.9D5755A842E55Bb7": "от близкого к далекому,",
    "asset.records.E3Fa05E607203Cdc": "пополнить",
    "asset.records.B4F206C6Bec08Dea": "отзывать",
    "asset.index.Df5B3A511D986576": "Вы успешно получили демо-ресурсы",
    "deposit.depositSpeedy.Efe81D0E0174239B": "способ оплаты",
    "deposit.depositSpeedy.B9293Ee96E435F85": "Фиатная валюта",
    "deposit.depositSpeedy.16658A855F07D171": "Количество",
    "deposit.depositSpeedy.204Ffab8A6E01870": "Конечно",
    "deposit.depositSpeedy.22E5Dfb74Ead8Aa9": "Не может быть пустым",
    "deposit.depositSpeedy.B8E774D0E4E5E4C1": "Минимальное пополнение",
    "deposit.depositSpeedy.F169D816F6Dd83C5": "Максимальная перезарядка",
    "deposit.depositWallet.F64Ec60B1Db4A6D6": "Депозит USDT",
    "deposit.depositWallet.551640C76F4Ca4A1": "Пополнить валюту",
    "deposit.depositWallet.B404C543712B71D5": "Пополнить сеть",
    "deposit.depositWallet.A484B0F5E94B3F4F": "Адрес депозита",
    "deposit.depositWallet.D3980D54Acf242Db": "Сохранить QR-код",
    "deposit.depositWallet.A06E84801D6582Be": "Сумма пополнения",
    "deposit.depositWallet.Daaaeb1B7B22B126": "намекать",
    "deposit.depositWallet.D599E40E1Eeec1B3": "Пополнение прошло успешно",
    "deposit.depositWallet.4F48Abbafce532Bb": "Отправлено успешно, ждём проверки службы поддержки клиентов",
    "deposit.depositWallet.A88C481228811696": "Вы отказались переключать сети",
    "deposit.depositWallet.C6Ebf27895C21932": "Пожалуйста, вручную откройте плагин кошелька TRON и войдите в систему.",
    "deposit.index.B5491C8Dd09D8183": "Выберите валюту, которую хотите пополнить",
    "deposit.index.2F784B2298D39987": "Быстрая перезарядка",
    "deposit.index.0Daa03Dcdcabd837": "Внешние ссылки",
    "withdraw.bottomSheet.628A63056Ef2D2Fe": "Подтверждение вывода средств",
    "withdraw.bottomSheet.A086Fa20082C849D": "Пожалуйста, убедитесь, что информация ниже верна",
    "withdraw.bottomSheet.Bf8B184D32971501": "Сеть вывода средств",
    "withdraw.bottomSheet.8758Fd50C87D6C9C": "адрес",
    "withdraw.bottomSheet.F9Db93B87E08763B": "количество",
    "withdraw.bottomSheet.4Ad26475002878C0": "плата за обработку",
    "withdraw.index.A96454041169Af6D": "Выберите валюту",
    "withdraw.index.2A563B7081Dd5B83": "Выберите валюту",
    "withdraw.index.B189C2Ef713Cfff4": "Сумма выведенных монет",
    "withdraw.index.558F35140E84B562": "Доступный：",
    "withdraw.index.F4E759087E12Cb77": "Вывести все",
    "withdraw.index.5Cbd9A6B284D25Ae": "Пароль фонда",
    "withdraw.index.B89Cbe4Bfc33Bb41": "плата за обработку:",
    "withdraw.index.C886De8D8A27026E": "важное замечание",
    "withdraw.index.Eac7C5A4095F5606": "1.Чтобы предотвратить арбитраж, вы можете подать заявку на вывод валюты, когда объем транзакции достигнет квоты.",
    "withdraw.index.C3Cc7Fff24504Be9": "2.Заявка на вывод средств будет зачислена в течение 24 часов после подачи. Если вывод средств не получен по истечении расчетного времени вывода, обратитесь в онлайн-службу поддержки клиентов.",
    "withdraw.index.0B4Ad7Ccdc833B0D": "3.После подачи заявки на вывод средства находятся в замороженном состоянии, поскольку вывод продолжается и средства временно удерживаются системой. Это не означает, что вы потеряли актив или что с активом возникла неисправность.",
    "withdraw.index.4639F3A6E07C00B3": "Следующий шаг",
    "withdraw.index.81Fba0D65Cc5C3Aa": "Пожалуйста, введите или вставьте адрес вашего кошелька",
    "withdraw.index.25768141C8Bdea91": "Пожалуйста, введите сумму вывода",
    "withdraw.index.97A85734Cd1B7Bf0": "Пожалуйста, введите пароль фонда",
    "withdraw.index.39C7D74B33241C78": "Сумма вывода указана неверно",
    "withdraw.index.86A5D17908197525": "Подтверждение вывода, ожидание проверки для выпуска монет)",
    "withdraw.index.48Fb603C6638C7F6": "Пожалуйста, установите пароль фонда",
    "withdraw.index.873Ade9A3Bacc2F7": "намекать",
    "bill.index.5Bbb2A6Ac68D6B2E": "фактический счет",
    "bill.index.75751E0Eb8261C40": "Демо-счет",
    "bill.index.Cbc853B37Ecc2E97": "Тип изменения аккаунта",
    "bill.index.4A0Cacddeb2E38B1": "тип аккаунта",
    "bill.index.F16217028E098B2F": "Валюта",
    "bill.index.A620Dbe6F06B78Ba": "Все типы",
    "bill.index.2C3C148Bb94D9B3F": "Все аккаунты",
    "c2C.index.Ab45695E4Bf1E382": "C2C-транзакция",
    "c2C.index.2702Dc911Dfea762": "я хочу купить",
    "c2C.index.D737D5B8367A53C4": "я хочу продать",
    "c2C.index.C0C540A3Ba9Abe01": "Объем",
    "c2C.index.D8644E8D60C8Bd8A": "цена за единицу товара",
    "c2C.index.Ebb8670B203D3604": "предел",
    "c2C.index.F8C6245A2Ebf1D27": "Все банковские карты",
    "c2C.index.F8C6245A2Ebf1D28": "сбор валюты",
    "c2C.index.F8C6245A2Ebf1D29": "банковская карта",
    "c2C.index.Cc3Aa8141Da9Ec9E": "Купить",
    "c2C.index.Cc3Aa8141Da9Ec9F": "продавать",
    "c2C.index.67A39834582Ad99A": "Нет данных",
    "c2C.order.04C23810B47F77F7": "по сумме",
    "c2C.order.6905365902E0A73D": "по количеству",
    "c2C.order.3F0Ecebbd9D2F23B": "Доступный",
    "c2C.order.16853Bda54120Bf1": "все",
    "c2C.order.Ad3335796F2C95F7": "Общая сумма",
    "c2C.order.61092E27A6879318": "Чтобы обеспечить безопасность активов, повысьте свою осведомленность о мерах профилактики!",
    "c2C.order.0F51881F0Fb920B2": "Торговая информация",
    "c2C.order.Dd74Ceca85E5Bc65": "Срок оплаты",
    "c2C.order.De3341388A59073F": "30 минут",
    "c2C.order.D334B597A352167F": "Никнейм продавца",
    "c2C.order.D334B597A352167G": "Никнейм покупателя",
    "c2C.order.9D5F89F99Ced890D": "средство сделки",
    "c2C.order.8Adf755B14Bc6B7C": "Пожалуйста, сначала прочитайте следующее",
    "c2C.order.686B16F454A7338B": "Не делайте никаких замечаний при переводе на банковскую карту, иначе деньги не будут выданы, а счет будет напрямую заблокирован. После оплаты вам необходимо предоставить новую диаграмму деталей транзакции после оплаты (если на платформу сообщается P-диаграмма или скрытые детали транзакции для заморозки учетной записи)",
    "c2C.order.9Bec8Fba867B739B": "Выберите метод оплаты",
    "c2C.order.Cf2D892C419Fea36": "минимальная покупка",
    "c2C.order.7290A6B7456A03E0": "крупнейшая покупка",
    "c2C.orderConfirm.F7E99B8C203E2B07": "Информация для заказа",
    "c2C.orderConfirm.036D94Dc2D1Cf7D3": "Заказ создан",
    "c2C.orderConfirm.0F5433503F3845Ce": "Пожалуйста, заплатите продавцу в течение обратного отсчета.",
    "c2C.orderConfirm.24C3Bcacdb85A451": " Ожидание оплаты покупателя ",
    "c2C.orderConfirm.8E8140D7Ab607B24": "связаться с продавцом",
    "c2C.orderConfirm.8E8140D7Ab607B25": "связаться с покупателем",
    "c2C.orderConfirm.Ec4D8722Ec15C813": "Цифровая валюта продавца теперь зачислена на целевой депозитный счет, пожалуйста, не стесняйтесь платить. ",
    "c2C.orderConfirm.69D1Fbbc7700C1Ab": "Настоящее имя покупателя：",
    "c2C.orderConfirm.E5Ed8Ec53Edcd5D3": "Круглосуточная служба поддержки клиентов 7x24 ",
    "c2C.orderConfirm.Abf9F4B8C93D641E": "номер заказа",
    "c2C.orderConfirm.726C51702F70C486": "время создания",
    "c2C.orderConfirm.E097Bb9B1216Bfd8": "Свяжитесь со службой поддержки клиентов",
    "c2C.orderConfirm.103408Fbbe30287F": "отменить заказ",
    "c2C.orderConfirm.4E93Df1Fb521F4Ba": "Я подтвердил оплату",
    "c2C.orderConfirm.3B5418Dbea7Ebfe4": "Уже оплачено",
    "c2C.orderConfirm.387Ca3625B260E4E": "Ваш оплаченный заказ",
    "c2C.orderConfirm.7C83D5F1Db1A08B7": "отменить транзакцию",
    "c2C.orderConfirm.76C86566Cc3751C0": "Заказ отменен",
    "c2C.orderConfirm.205B349751D176B4": "платеж успешен",
    "c2C.paymentAdd.6F2A7Dcc66E6Acba": "способ оплаты",
    "c2C.paymentAdd.C87E865Df6800304": "Настройка способа оплаты",
    "c2C.paymentAdd.B59Ae0F1B1C235Df": "Тип способа оплаты",
    "c2C.paymentAdd.06910Bddf002695F": "настоящее имя",
    "c2C.paymentAdd.3E33Ae3Efa7507Dd": "Счет PayPal",
    "c2C.paymentAdd.3E33Ae3Efa7507De": "Номер банковского счета/номер карты",
    "c2C.paymentAdd.3E33Ae3Efa7507Df": "Название валюты",
    "c2C.paymentAdd.595Ede91Abf6F6E0": "Оплатить QR-код",
    "c2C.paymentAdd.1Ecc8Be9Ba1C940A": "Нажмите, чтобы загрузить",
    "c2C.paymentAdd.6Daae340F2E9718A": "название банка",
    "c2C.paymentAdd.347751415C3Da489": "Название сети",
    "c2C.paymentAdd.15B3627Faddccb1D": "Примечание",
    "c2C.paymentAdd.86Da96Cbd274058F": "Напоминаем: когда вы продаете цифровую валюту, выбранный вами способ оплаты будет показан покупателю. Пожалуйста, подтвердите правильность заполнения информации.",
    "c2C.paymentAdd.4Ce9979Bfb6576D9": "сохранять",
    "c2C.paymentAdd.90D2A3A5C07179C0": "пожалуйста, введите свое настоящее имя",
    "c2C.paymentAdd.A3B0Cd3Ad9Ca3475": "Пожалуйста, введите свой",
    "c2C.paymentAdd.Ec389E6190Eedb62": "Пожалуйста, введите название вашего банка",
    "c2C.paymentAdd.9Be51Fb1E9025Fb2": "Пожалуйста, введите название вашей сети",
    "c2C.paymentAdd.94F034F0E01439E0": "Пожалуйста, введите ваш адрес",
    "c2C.paymentAdd.B12E035663A42B32": "Все банковские карты",
    "c2C.paymentAdd.C7B677F393A8F8Ac": "сбор валюты",
    "c2C.paymentAdd.Abafe11737Bab7Cd": "Пожалуйста, загрузите код платежа",
    "c2C.paymentAdd.07C443212Ff04Bfb": "Добавлено успешно",
    "c2C.paymentDetail.86Da96Cbd274058F": "Напоминаем: когда вы продаете цифровую валюту, выбранный вами способ оплаты будет показан покупателю. Пожалуйста, подтвердите правильность заполнения информации.",
    "c2C.paymentDetail.C4C613Da60226De4": "Успешно изменено",
    "c2C.paymentMethod.7609F7C8337C7A17": "C2C способ оплаты",
    "c2C.records.9E36893D5736Abb4": "Список заказа",
    "c2C.records.4B53F9A5B13B3235": "Ожидает платежа",
    "c2C.records.4B53F9A5B13B3236": "отменить транзакцию",
    "c2C.records.4B53F9A5B13B3237": "Уже оплачено",
    "contract.index.9706Df877458F0Be": "Полный склад",
    "contract.index.623Fc7D3D40Aa479": "Начальная маржа",
    "contract.index.F92Dce1169330387": "Рыночная цена фиксирована",
    "contract.index.3598B97Dd28Dbf20": "Пожалуйста, укажите количество (шт.)",
    "contract.index.6E1Fae821Dc0B797": "Устойчивый",
    "contract.index.Eb07Eb0C37C14575": "Доставка",
    "contract.index.Eb6492F19B1C1Fb6": "Подробности исторических транзакций",
    "contract.index.873Ade9A3Bacc2F7": "намекать",
    "contract.index.Ff63B0F93D39F50B": "Ты уверен, что прав?",
    "contract.index.Ff63B0F93D39F50D": "Идти долго",
    "contract.index.Ff63B0F93D39F50E": "короткий",
    "contract.index.Ff63B0F93D39F50F": "руководить",
    "contract.index.Ff63B0F93D39F50G": "Закрыть все позиции?",
    "customer.dialog.3D410C88E8A24Fe8": "Подтвердите псевдоним",
    "customer.dialog.4B3340F7872B411F": "Отмена",
    "customer.dialog.549B1456Bb5F98B3": "Пожалуйста, введите свой никнейм",
    "customer.dialog.B773B3E45Ccfad00": "Никнейм пуст",
    "customer.index.7308C6B849D159E9": "Детали изображения",
    "delivery.callDialog.C74F562C3Fe91Fe3": "успешно заказан",
    "delivery.callDialog.B8C98F42Caa15Ca5": "направление",
    "delivery.callDialog.B79A581Dae543974": "долго покупать",
    "delivery.callDialog.B79A581Dae543975": "короткая покупка",
    "delivery.callDialog.3B26F0F7E90773F3": "Цена открытия",
    "delivery.callDialog.65Fb252Bd94E1039": "Предполагаемый доход",
    "delivery.index.B483Ba4Fce633539": "Доставка",
    "delivery.index.224Dd6Cb58D58249": "торговый период",
    "delivery.index.28158F517E902788": "Минимальный бай-ин",
    "delivery.index.A1232162B14Bec76": "Доставка заказа",
    "delivery.index.445B1D3176D9C69D": "Исторические порядки",
    "delivery.index.Ab6Cb86E28653C5C": "Доставка",
    "delivery.index.20A7A6F14D3698C0": "Время открытия",
    "delivery.index.Ec6821A49395Ddc2": "Время закрытия",
    "delivery.index.254Fdc665C391743": "Цена закрытия",
    "delivery.index.2A0C5E68B44A472A": "Доходы и расходы",
    "delivery.index.E05B33309F6D236A": "Пожалуйста, введите количество",
    "delivery.index.B2899E073Cb355D9": "Минимальная покупка",
    "download.description.869467A93C7Dd4A1": "Примечания по установке",
    "download.description.C80C1Edd6Bee12Bc": "1.Разрешить загрузку файлов описаний",
    "download.description.2F5Bc180F92642B4": "2.Файл с описанием скачан.",
    "download.description.3C3B849F6Ccf712F": "3.Войдите в [Настройки] на своем телефоне, и загруженный файл описания отобразится под информацией об учетной записи.",
    "download.description.86Affd862985E045": "4.Нажмите, чтобы скачать файл описания",
    "download.description.32832492Bfc1D95E": "5.Нажмите, чтобы установить",
    "download.index.245883C80F181C4A": "скачать",
    "download.index.Ef3De8Cb2722937A": "Начните торговать в любое время и в любом месте",
    "download.index.F4A87Eaeed691638": "Будьте в курсе последних новостей через наше приложение",
    "download.index.Ad3Aba52D0D39D01": "Загрузите установочный пакет",
    "download.safariGuide.61Bd9A8Fcc2Ea788": "Добрые советы",
    "download.safariGuide.2Cc68Aaadf623477": "Пожалуйста, посетите в Safari",
    "download.safariGuide.C80Fff2A6Ff4E768": "Вы посещаете децентрализованный веб-сайт, запустите приложение Safari.",
    "download.safariGuide.06Da016F3E2F79Bd": "копировать ссылку",
    "finance.index.B034B367545D5236": "Глобальные высококачественные проекты",
    "finance.index.6Ebfac2C0A9228B0": "1,6 млн+ активных пользователей, 122,4 млрд долларов США",
    "finance.index.52Bdcaf19659363D": "Майнинг ликвидности",
    "finance.index.D66924272B031Bf5": "Сверхвысокий годовой доход",
    "finance.index.34789D88Afcefa64": "Посмотреть элементы",
    "finance.index.E12676B95654D21E": "кредитный заем",
    "finance.index.4C924Cfd89A11Ac7": "Откройте для себя больше торговых возможностей",
    "finance.index.C251D4B594Da2848": "оценка ИИ",
    "finance.index.4E53Cf2E5F173Dd3": "Лизинг в один клик, интеллектуальная транзакция с использованием искусственного интеллекта",
    "finance.records.Cce168301447D1Ba": "в ходе выполнения",
    "finance.records.4587B6Bd7Cfa4454": "искуплен",
    "finance.records.18685418E3A50147": "Добыча",
    "finance.records.Df9Fd438F97Cc908": "небо",
    "finance.records.E23Cb03C5Ad359E5": "термин",
    "finance.records.Bd87Dac6Cba7Eba8": "Количество покупок",
    "finance.records.2D0Fff99265E8B1A": "Выгодный",
    "finance.records.2D0Fff99265E8B1B": "Прибыль при погашении",
    "finance.records.024F5F0B851782De": "Время майнинга：",
    "finance.records.3143A26D3F983896": "время выкупа：",
    "finance.records.96574Aaf8Db85Ead": "досрочное погашение",
    "finance.records.531E1829203181Ac": "Вы уверены, что хотите активировать досрочно?",
    "finance.records.9205843B8923Dac3": "Погашение успешно;",
    "loan.applyCallback.B9258Ec8746A74D8": "Заимствование канала",
    "loan.applyForm.7B8Ed340400A6E2B": "имя",
    "loan.applyForm.549A44Bae725F4A2": "фамилия",
    "loan.applyForm.2A27E61375E7Fea8": "Дата рождения",
    "loan.applyForm.89925B019D537738": "Адрес электронной почты",
    "loan.applyForm.Afaeb32Cb4D62E28": "Домашний адрес (включая номер квартиры)",
    "loan.applyForm.E05B5D049B64B040": "Город",
    "loan.applyForm.B166E4E8Fe9513Fa": "нация",
    "loan.applyForm.83Aaede109E395F8": "Почтовый индекс",
    "loan.applyForm.647Ed21332A4968B": "ваш ежемесячный доход",
    "loan.applyForm.Cf0A9B845D34D4B4": "Дополнительный доход (необязательно)",
    "loan.applyForm.7048F618Acc6A54C": "Ежемесячная арендная плата или ипотечный платеж",
    "loan.applyForm.15C1Bba18Ae18545": "Сообщите нам, есть ли у вас ипотека",
    "loan.applyForm.3921E90625A84E36": "Если гарантия по ипотеке не выбрана, вероятность прохождения проверки мала.",
    "loan.applyForm.262Eec4F8906B0F6": "Есть ли ипотека?",
    "loan.applyForm.8634Eb21B6910F21": "Пожалуйста, выберите тип ипотеки",
    "loan.applyForm.A4897B3A331B5E61": "Ваучер транзакции",
    "loan.applyForm.6623384C683De457": "Будем на связи",
    "loan.applyForm.A8360Bdba86834Cb": "Мы можем связаться с вами по этому номеру, если нам понадобится дополнительная информация о вашей заявке на кредит.",
    "loan.applyForm.C1C373F385A4C7B3": "номер телефона",
    "loan.applyForm.1B9785Badb91191F": "После заполнения информации дождитесь оценки и проверки системы.",
    "loan.applyForm.8755B9C761D4080C": "Я прочитал и подписал электронно свое согласие",
    "loan.applyForm.3E987B787468148C": "Условия использования и электронное согласие",
    "loan.applyForm.Bc54E76B61C50Fb9": "Пожалуйста, прочтите и согласитесь с соглашением",
    "loan.applyForm.89E158384F634Eb8": "Вернуться к предыдущему шагу",
    "loan.applyForm.Efa5A4548E2F3510": "Домашний адрес",
    "loan.applyForm.4Cadf1787541B35D": "да,",
    "loan.applyForm.Fab408D2F4100447": "нет,",
    "loan.applyForm.3Bad7A307480Cc56": "Формат электронной почты неправильный;",
    "loan.applyForm.306322F49B36855D": "Заявка отправлена, дождитесь рассмотрения службы поддержки клиентов.",
    "loan.applyForm.3C6E0E858C995Ff9": "Пожалуйста, загрузите ваучер транзакции",
    "loan.applyForm.2Bf443476B271376": "Можно загрузить до 4 фотографий.",
    "loan.applyQuota.Ef1D8E23003B9A6F": "Заимствование канала",
    "loan.applyQuota.Ef1D8E23003B9A6G": "Получить кредитный лимит",
    "loan.applyQuota.9E0780F9352C7273": "баланс кошелька",
    "loan.applyQuota.Cbc1Eb9D639A6105": "Общая доступная сумма кредита",
    "loan.applyQuota.033A05462195B080": "Сумма займа",
    "loan.applyQuota.9Aa89B036Ef4821D": "остаток средств",
    "loan.applyQuota.5656Fb52Ef17A557": "Получить кредитный лимит",
    "loan.applyQuota.6Ff6702B4C917D40": "на рассмотрении",
    "loan.applyQuota.6Ff6702B4C917D41": "отклоненный",
    "loan.applyQuota.6Ff6702B4C917D42": "удалось",
    "loan.applyQuota.0Bad0E857Ea4A952": "время подачи заявки",
    "loan.applyQuota.3E7E56E2De2Cc546": "Сумма заявки",
    "loan.applyQuota.8F1D170D9E54Af5B": "Ход применения",
    "loan.applyQuota.6167Ca035B93Caf3": "причина",
    "loan.applyQuota.410C7954F9A3981D": "Повторно подать заявку",
    "loan.bottomSheet.61Cd62F861D8F5B2": "Пожалуйста, выберите валюту",
    "loan.index.4C10307B22E885C3": "Откройте для себя больше торговых возможностей и создайте богатство",
    "loan.index.Ae8D37Dea2B3717B": "процентная ставка",
    "loan.index.1Bb54625682E85Db": "Введение в правило",
    "loan.index.5Bd31Fab681C6E9D": "узнать больше",
    "loan.index.111F95F404814327": "Валюта кредита",
    "loan.index.6Bc2723B3Bec106D": "заем",
    "loan.index.3200106280E6E370": "процентная ставка",
    "loan.index.049A6Ccb6C81A635": "Сумма кредита (мин/макс)",
    "loan.productDetails.5037Ad86Ab4B7E02": "заем",
    "loan.productDetails.37181C74559Db182": "Заказ ",
    "loan.productDetails.5802Aaf06A1E4755": "Ликвидность",
    "loan.productDetails.89Aea9Cf9337C40F": "Количество, доступное для заимствования",
    "loan.productDetails.9E419Ae2D06F3Ad9": "Сумма к погашению",
    "loan.productDetails.C65F329Ef14C4A3D": "Сумма заемных монет",
    "loan.productDetails.3A74667815Adc8Bf": "максимум",
    "loan.productDetails.Ab851D8351573227": "небо",
    "loan.productDetails.Ddf82D8A2C8F46A0": "цикл погашения",
    "loan.productDetails.C105E5562005Aeb1": "небо",
    "loan.productDetails.3F346Be2137F0756": "Сумма кредита (мин/макс)",
    "loan.productDetails.2707F78Df864E194": "Интерес",
    "loan.productDetails.B9Dc9B81E726Bdf1": "Пожалуйста, погасите долг вовремя. В случае просрочки взимается дополнительная ежедневная сумма в размере (основная сумма + проценты).",
    "loan.productDetails.B9Dc9B81E726Bdf2": "% — просроченная плата",
    "loan.productDetails.4D94Faa033Be7356": "Я согласился",
    "loan.productDetails.62429A957A22780A": "Соглашение об оказании услуг по кредитованию монет",
    "loan.productDetails.Bc54E76B61C50Fb9": "Пожалуйста, прочтите и согласитесь с соглашением",
    "loan.productDetails.Ec8Ba071C53A67Cb": "Одолжить сейчас",
    "loan.productDetails.59246A0Bf081D398": "наименее",
    "loan.productDetails.Ec3F1172B71Cd36C": "минимальная сумма",
    "loan.productDetails.7Ccc4Cf1D81930B3": "наибольшая сумма",
    "loan.productDetails.071488598990Aa68": "Пожалуйста, прочтите и согласитесь с соглашением;",
    "loan.productDetails.579Dd216D3339119": "Кредит выдан;",
    "loan.records.4951B36Fd0D2A831": "Кредит и кредитная история",
    "loan.records.Bb0Aaa30514B7Cba": "текущий рекорд",
    "loan.records.0F8B0A7D80769051": "История погашения",
    "loan.records.D4B42E43D88De6F1": "запись истории",
    "loan.records.Cb1847D6281897E6": "Величина займа",
    "loan.records.C7Bfcacfc2Adea58": "Сумма погашения",
    "loan.records.8B369164D5Fea340": "Срок кредита：",
    "loan.records.Ab2402Ad3Ffd35E7": "Погасить кредит досрочно",
    "loan.records.B7A0Ca0C195D0Cd1": "Время выпуска：",
    "loan.records.42014Bdcfd9C411B": "Срок погашения：",
    "loan.records.A0Acfaee54F06458": "завершенный",
    "loan.records.67A39834582Ad99A": "Нет данных",
    "loan.records.6A687Ff5B8F1598F": "Вы уверены, что хотите погасить предоплату?",
    "loan.records.7C20D7008D0Eae86": "Погашение успешно",
    "mining.bottomSheet.Ba91637D32Ccba04": "Майнинг ликвидности",
    "mining.bottomSheet.7De3D636A165E008": "норма прибыли",
    "mining.bottomSheet.F3003345B189D683": "Период майнинга",
    "mining.bottomSheet.3E4C0A8C533F5848": "тип монеты",
    "mining.bottomSheet.Adcba368993Ae65E": "Сумма подписки (минимум/максимум)",
    "mining.bottomSheet.94743B24E4Ed4166": "Безлимитный",
    "mining.bottomSheet.286944Fedd211257": "Доступные средства",
    "mining.bottomSheet.7B5766Dc65Abc0C3": "Предполагаемый доход:",
    "mining.bottomSheet.9Bbaf80Fdb6Fd148": "Мой сейчас",
    "mining.bottomSheet.Bb1493C567C114Dd": "Добрые советы：",
    "mining.bottomSheet.D2315E87E34A3Bd3": "Плата за досрочное погашение",
    "mining.index.8B2Bba1422Eed6F0": "Создайте десятки миллиардов богатства, 100% чистый доход",
    "mining.index.42997E300086Ee89": "наивысшая доходность",
    "mining.index.510F74F42052Ecce": "Горнодобывающая продукция",
    "mining.index.B853F96626106912": "Займитесь майнингом",
    "mining.productList.37181C74559Db182": "Заказ",
    "mining.productList.Aac5B810004C46C8": "обычный",
    "mining.productList.D2Fb4F78C387D888": "Вы успешно добыли",
    "quantify.bottomSheet.9Ea4A318F690Bc95": "Подтвердите заказ",
    "quantify.bottomSheet.6915303B698303B1": "робот",
    "quantify.bottomSheet.68045296Dd0F8Ad6": "Сумма аренды",
    "quantify.bottomSheet.Fbd931286Be387Aa": "цикл",
    "quantify.bottomSheet.9Ad84Db481807844": "на неопределенный срок",
    "quantify.bottomSheet.994D7226Ca083Ea5": "Ежедневная доходность",
    "quantify.bottomSheet.0Bf82Ee4Bfe063B7": "дата валютирования",
    "quantify.bottomSheet.88008603Ba7Bde64": "Покупка прошла успешно",
    "quantify.bottomSheet.Ff50B3091Bbd09Ab": "Получайте долю дохода с этого момента！",
    "quantify.bottomSheet.C778A674C4A054F9": "проверить заказ",
    "quantify.bottomSheet.685Dad322B7029B0": "Возвратная сделка",
    "quantify.buyForm.Acf8560A04334E95": "закупочная цена",
    "quantify.buyForm.Cf9Cfbc2C554944F": "Обзор",
    "quantify.buyForm.8788Df2B625E97B5": "робот",
    "quantify.buyForm.50Ca63B45E881D50": "Срок выплаты дивидендов",
    "quantify.buyForm.Fcda03Adbc5Fca97": "каждый день",
    "quantify.buyForm.Afb89504Fc399189": "Пожалуйста, введите количество покупки",
    "quantify.buyForm.1435Afdfb4Ec0596": "Минимальный объем покупки",
    "quantify.buyForm.1B97F1730Bacd839": "Максимальное количество покупки",
    "quantify.index.32F56C9B7D0E250A": "Период: неопределенный",
    "quantify.index.E34F028D00904630": "цена",
    "quantify.index.E34F028D00904631": ",Ежедневная доходность",
    "quantify.productDetail.6Bbe178Df539A5Ca": "Сумма условного депонирования",
    "quantify.productDetail.53635B53Bca31Dfa": "Предполагаемый ежедневный доход",
    "quantify.productDetail.F9E46449A6269E09": "Совокупный доход",
    "quantify.productDetail.98Fc46B1B8C993B2": "Заказать хостинг",
    "quantify.productDetail.93624Bb045830966": "Арендовать сейчас",
    "quantify.records.0C16A18C32B9Cf4A": "Запись заказа",
    "quantify.records.B191F5614B0E2312": "История покупки",
    "quantify.records.6A06033B86A73F7C": "запись о погашении",
    "quantify.records.45E0F7E71611618E": "Совокупный доход",
    "quantify.records.45E0F7E71611618F": "Прибыль при погашении",
    "quantify.records.Aae1201E38C4Baaa": "Бег",
    "flash.index.C41Fd4F2Fdfa594B": "Доступный",
    "flash.index.1Ac59Fa2218E3B00": "Доступный:",
    "flash.index.Bf7233A660821549": "получать",
    "flash.index.548E775Dd67C7472": "Подтвердить обмен",
    "flash.index.066A2449Bd616F03": "Пожалуйста, введите сумму погашения",
    "flash.index.Fca26Fcf9C06563F": "Flash-погашение успешно выполнено",
    "message.index.40031524233F4564": "Центр сообщений",
    "message.index.8E5586210Fd44D69": "Контракт уведомлять",
    "message.index.Bcd3F470E88C197D": "Уведомлений пока нет",
    "message.index.23A557Fbce545879": "Контракт уведомлять",
    "message.index.B5E19B36B5125550": "Напоминание о снятии средств",
    "message.index.716A981465138334": "Напоминание о пополнении счета",
    "message.index.884474Ebff2977Ba": "системная информация",
    "message.index.08Cc7D24752Ec42C": "Интернет Сервис",
    "message.index.1D820A6A19Ab025D": "7 х 24 часа онлайн-ручное обслуживание",
    "more.index.29881E0B5Df58Bf7": "Больше возможностей",
    "more.index.C77Ee35911D10D9D": "Общие функции",
    "more.index.3558F69B0260Be61": "Торговая функция",
    "more.index.7243Fe610Ed98Cec": "реальный счет",
    "more.index.7243Fe610Ed98Ced": "Демо-счет",
    "more.index.693C7B35Bdf3E3A3": "финансы",
    "more.index.F855997Fac114554": "Центр помощи",
    "more.index.Ae9A1252278Da742": "помощь",
    "more.index.Ace012504Bc529E0": "информация",
    "more.index.05682Dbef5Eeb0A8": "обслуживание клиентов",
    "more.index.C7Af227A5D5C7Bb9": "Вы перешли на реальный счет",
    "more.index.D818A65592694786": "Вы перешли на демо-счет",
    "notice.details.B360807Dbe727E6E": "о нас",
    "notice.details.92F2552F695E70E3": "о нас",
    "notice.details.7Aaceaf69B67F3D1": "Введение в правило",
    "notice.index.6128438Be34Bcb9F": "Постоянное уведомление",
    "notice.index.71627F5Eb7128261": "Уведомление о снятии средств",
    "notice.index.2Dce570Fda841705": "Уведомление о пополнении счета",
    "notice.index.228A7C9C6448A9B1": "системное уведомление",
    "setting.dialog.8B4F5B74660Deabe": "Цветовая конфигурация",
    "setting.dialog.Bfc7D25486Ebc1A9": "Зеленый поднимается, а красный падает",
    "setting.dialog.796Ea0E1A82C320B": "Красный поднимается и зеленый падает",
    "setting.index.8Ddc5864E1739466": "Предпочтения",
    "setting.index.F5205801D57D6727": "язык",
    "setting.index.2E2C12Dd0Cc1B63B": "Валюта котировки",
    "setting.index.322D8496Aec3D918": "номер версии",
    "setting.index.Aa7E6C204C751Cfa": "выход",
    "share.index.75Bc38Bbf7D2E766": "пригласить друзей",
    "share.index.45575Eb5D42213E6": "мой код приглашения",
    "share.index.29F67F0644A78Bf3": "копировать",
    "share.index.19Cc65Bb6Bb98Fe7": "Моя ссылка-приглашение",
    "share.index.5372712F162Fb78B": "Количество прямых подчиненных",
    "share.index.C88D6B95E3Ab7D6F": "Общее количество подчиненных",
    "share.index.Bb5Fa5471Aeecc62": "Комиссионная скидка для прямых подчиненных",
    "share.index.426B6Bac9A5F3D4F": "общая скидка",
    "share.index.197E4A428F0401C9": "Просмотр записей о скидках",
    "share.records.88A6B2E2B74B13C4": "Запись комиссии",
    "share.records.B671A35Ffdc93B89": "Скидка",
    "transfer.index.B17617A869C03Ca5": "кошелек",
    "transfer.index.E4116Dcc6F6C7270": "Перенос успешен",
    "transfer.index.48Fb603C6638C7F6": "Пожалуйста, установите пароль фонда",
    "transfer.records.Eb0E39Eb5911D418": "получать",
    "transfer.records.977554Be0Aa65052": "Время погашения флэш-памяти：",
    "transfer.records.9Aa33884Aa400B7C": "время передачи：",
    "form1.forget.76636Db8Fae5B124": "твой почтовый ящик",
    "form1.forget.35354B9Cca1Bb0E6": "Код подтверждения электронной почты",
    "form1.forget.604A0B11E916F387": "пароль",
    "form1.forget.9Cb1C9C51E7503D6": "Подтвердите пароль",
    "form1.forget.3A4F7E04B008453C": "Ваш номер телефона",
    "form1.forget.Cf11Dce5B4713B5A": "Код подтверждения мобильного телефона",
    "form1.forget.3012Edba57D4F297": "Пожалуйста, введите свой адрес электронной почты",
    "form1.forget.F1Ee1D97E869E447": "пожалуйста, введите код подтверждения",
    "form1.forget.3A5C4C9Ae68Fa0F6": "Пожалуйста введите ваш пароль",
    "form1.forget.C6Cb174Da411D5F7": "Пожалуйста, введите свой мобильный телефон",
    "form1.forget.947B3B21Ee45E582": "отправлять",
    "form1.forget.3E0580F1E8630Df6": "Два пароля несовместимы",
    "form1.forget.C5A61836B8Cc74C6": "Изменение пароля успешно перенаправлено...",
    "form1.forget.B96D072Bc8962565": "Отправить",
    "form1.login.2B72C27Ff828Cfc4": "ваш пароль",
    "form1.login.D7C6B872Af9Cb17F": "запомнить мой пароль",
    "form1.login.0Fff44C827A4F3B6": "Авторизоваться",
    "form1.login.1B7F2C1Ede3990Cc": "Нет аккаунта? Зарегистрироваться",
    "form1.login.F657F7Be1Cc33Bd2": "забыть пароль",
    "form1.login.2074A1Eec4B088B0": "Вход в кошелек",
    "form1.login.1B8938Fbcc3C9B56": "Вход успешен и происходит перенаправление...",
    "form1.login.07162A7Bb9310555": "Пожалуйста, установите кошелек ERC20",
    "form1.login.766969966Ae151Dc": "Пожалуйста, установите кошелек TRC20",
    "form1.login.B88171E1Ad4C50Bf": "Вы отказались переключать сети",
    "form1.register.Aaef0710Cb4Db554": "Введите пароль еще раз",
    "form1.register.54Dfea0415C708Ff": "Код приглашения",
    "form1.register.6839940Dac08C794": "регистр",
    "form1.register.9901A3B5550Aa58E": "У вас уже есть аккаунт? Авторизоваться",
    "form1.register.2548Ca53785252Ea": "Пожалуйста, введите код приглашения",
    "form1.register.Dd71Fd65900Dd03E": "Пожалуйста, прочтите Соглашение об оказании регистрационных услуг и согласитесь,",
    "form1.register.7975613909490B77": "Регистрация прошла успешно, происходит перенаправление...",
    "form1.walletDialog.105829Acfc0Bd6Aa": "Выбрать кошелек",
    "userc.certification.2Af9511640153D2E": "Младшая сертификация",
    "userc.certification.177B191D8E0Fa84D": "не удостоверен",
    "userc.certification.601218D4D572E98A": "проверено",
    "userc.certification.6E37C51Ba9012Fc8": "Не прошел",
    "userc.certification.1B9B563E05C96474": "Расширенная сертификация",
    "userc.certification.1418B83803Ab56B4": "Пожалуйста, сначала пройдите первичную сертификацию",
    "userc.creditScore.0B149112601Acc4D": "кредитный рейтинг",
    "userc.creditScore.88Ac7F84E106C5F6": "общий кредитный рейтинг",
    "userc.creditScore.3E1D6E0E7F1E6155": "Оценка системы",
    "userc.index.62Eac58D04Bbca0F": "Персональный центр",
    "userc.index.F4Cac53F93Cb2Aff": "симулированная торговля",
    "userc.index.42F409Fdf3559773": "Центр безопасности",
    "userc.index.1B8E211009807Db8": "Аутентификация",
    "userc.index.Bdfcf21Eb8F2Eb70": "Записи об изменении учетной записи",
    "userc.index.6C18D67F6D19586B": "Записи об изменении учетной записи",
    "userc.index.807A814Ed58A93Bc": "очистить кэш",
    "userc.index.E43Daad59759611C": "не сертифицирован",
    "userc.secureCenter.F5C70F0Db2F1Ba76": "Изменить пароль для входа",
    "userc.secureCenter.1F37Ba427Debf24A": "Привязка аккаунта",
    "userc.secureCenter.F9A5Ffa750664004": "Привязать Google Authenticator",
    "userb.certificationForm.7685Af7D30043Cd6": "Младшая сертификация",
    "userb.certificationForm.7685Af7D30043Cd7": "Расширенная сертификация",
    "userb.certificationForm.70E37C35Abc3F462": "Страна",
    "userb.certificationForm.F92C25A68E4D08C5": "Город",
    "userb.certificationForm.0Ccc6387B38E0318": "Ваше имя",
    "userb.certificationForm.94C67Bba370Fdd46": "лицензионный номер",
    "userb.certificationForm.B2D4C7Fffe79258E": "Почта",
    "userb.certificationForm.57554268761Fb47A": "Загрузите лицевую сторону вашего удостоверения личности",
    "userb.certificationForm.D79E90201F5319Bd": "Загрузите обратную сторону своего удостоверения личности",
    "userb.certificationForm.9C6Bad08Af29E20E": "Загрузите фотографию своего удостоверения личности",
    "userb.certificationForm.F96B62Dfa31Cde45": "Подтвердить отправку",
    "userb.certificationForm.2125D78Ea8C6D287": "Требования к загрузке",
    "userb.certificationForm.0D64864D3076A824": "Посмотреть пример",
    "userb.certificationForm.35287Deb72281E87": "1.Посмотреть пример。",
    "userb.certificationForm.3007F2E01Efc7B57": "2.Содержание фотографии является правдивым и действительным, никакие изменения не допускаются.",
    "userb.certificationForm.25A90660554319F9": "3.Идентификационный номер и имя должны быть четко видны, поддерживать JPG/JPEG/PNG.",
    "userb.certificationForm.5A9Aefbc03C778F7": "Пожалуйста входите",
    "userb.certificationForm.3B7A1D8Ce27C937E": "Отправка прошла успешно, дождитесь проверки",
    "userb.certificationForm.744Bd07D8Abd2513": "Пожалуйста, загрузите лицевую сторону вашего удостоверения личности",
    "userb.certificationForm.6De1C319130F7Fef": "Пожалуйста, загрузите обратную сторону вашего удостоверения личности",
    "userb.certificationForm.79F8E8B172E30C8A": "Пожалуйста, загрузите фотографию вашего удостоверения личности",
    "userb.certificationForm.46412E16D28A4753": "Не удалось загрузить фотографию.",
    "userb.changeDialog.676B0Adca1F8Eea4": "изменить пароль",
    "userb.modifyInfoDialog.F41De3A1Fa69135A": "номер телефона",
    "userb.modifyInfoDialog.3C3Aac9664A35Ef8": "переключатель валидатора",
    "userb.modifyInfoDialog.62149E566814154C": "Выберите валидатор",
    "userb.modifyInfoDialog.8E69468E2435Fc89": "Откройте приложение аутентификации и нажмите +",
    "userb.modifyInfoDialog.7625E5Bdcbfe9963": "Выберите «Сканировать QR-код» или «Ввести ключ».'",
    "userb.modifyInfoDialog.93F094E2B4369472": "Отсканируйте QR-код или введите ключ",
    "userb.modifyInfoDialog.43E4F1532529Ee1E": "закрыть/открыть",
    "userb.modifyInfoDialog.Bae6358Dfd95025A": "Старый пароль фонда",
    "userb.modifyInfoDialog.E1133Cd4B1C2Abb7": "Новый пароль фонда",
    "userb.modifyInfoDialog.C1Ce0403A2523Ee0": "Подтвердите новый пароль фонда",
    "userb.modifyInfoDialog.8Dd453Adc2Cd78Fb": "Подтвердите пароль фонда",
    "userb.modifyInfoDialog.Bb0D9854C79325Bb": "Пожалуйста, введите старый пароль фонда",
    "userb.modifyInfoDialog.E66Cb29B00Bc54D1": "Пожалуйста, введите новый пароль фонда",
    "userb.modifyInfoDialog.E8Ae2Ec5Df401255": "Пожалуйста, введите пароль вашего фонда",
    "userb.modifyInfoDialog.258A534498Fe984F": "Пожалуйста, подтвердите пароль вашего фонда",
    "userb.modifyInfoDialog.768Ec43Faa193F08": "Привязка аккаунта",
    "userb.modifyInfoDialog.D34746090C25E5Db": "Пароль фонда",
    "userb.modifyInfoDialog.E4F27D8916E5E536": "подтверждать",
    "userb.modifyInfoDialog.Bef7160Ce53773E0": "Валидатор закрыт",
    "userb.modifyInfoDialog.Be8Bf47Ba6820De1": "Проверка Google успешно включена",
    "userb.modifyInfoDialog.24Dba26593F43C74": "Пароль фонда успешно изменен",
    "userb.modifyInfoDialog.5C369D42Dc7Dbe76": "Пароль фонда успешно установлен",
    "userb.modifyInfoDialog.667Bf8D0B6C36D4C": "Привязка прошла успешно",
    "userb.modifyInfoDialog.1C5E05Efee2B0B9F": "Ошибка кода подтверждения",
    "userb.veBottomSheet.Eecc4683C725F6F2": "Пример загрузки сертификата",
    "userb.veBottomSheet.6F38A0D5858633Ee": "темный чистый фон",
    "userb.veBottomSheet.Af162Dbdfc4Fcae9": "Достаточное освещение",
    "userb.veBottomSheet.0F7Baf0Cee3C8141": "Дополнительная рама для выравнивания",
    "userb.veBottomSheet.Ac9E471Eead0Cf11": "Фотографии четкие",
    "userb.veBottomSheet.50B741382E71F103": "Возможные причины неудачи",
    "userb.veBottomSheet.Aa56C68E8Fd4Cfb4": "Защитная крышка ID-карты не снята",
    "userb.veBottomSheet.5D2F429C75D4C7F2": "На фон влияет беспорядок",
    "userb.veBottomSheet.90F42D3Cb7769Dbc": "Удостоверение личности является светоотражающим.",
    "userb.veBottomSheet.1Ee78Cee782D81B4": "Свет слишком темный/загораживает тень мобильного телефона",
    "userb.veBottomSheet.1A75D2Fc2614592B": "наличие удостоверения личности",
    "home.home.C3525Eb110Db58Aa": "Более",
    "home.home.29761532Fc8Ebecc": "торговля",
    "home.home.F15Ea99Bfa6E1848": "Сертификация безопасности, покупайте с уверенностью",
    "home.home.46E1Ab39Bae7182A": "Быстрый",
    "home.home.Fde2Eb7F6F3Dd800": "Быстрые транзакции и простое управление",
    "home.home.Ea4756Bc1642E0F1": "имя",
    "home.home.B6B1127Ede1C97B4": "последняя цена",
    "home.home.3587Ad870Eb0Ab86": "24H вверх вниз",
    "home.home.Cb1A4E14Ec2Cd2B5": "Обнаружить",
    "home.home.0F1B1Ac0E96A40D1": "Блокчейн",
    "home.home.8Eaefb1107A0E210": "Форекс",
    "home.home.Ad65263D034Ea051": "Металл",
    "home.home.5Fc1474Dbf74Ac1A": "хозяйство",
    "home.home.135318F4664F7773": "энергия",
    "kline.kLine.C96Ff250Cf6B8B84": "24H Наибольший",
    "kline.kLine.6E8Be64F19D74565": "24H Объем",
    "kline.kLine.08A4Bfbe26A0F262": "24H самый низкий",
    "kline.kLine.8701Deb075066331": "Объем торгов за 24 часа (USDT)",
    "kline.kLine.Ea3C3052136C84Cd": "1 точка",
    "kline.kLine.B49Cca240E013124": "5 точка",
    "kline.kLine.F27A90Be97Ba3D6C": "15 точка",
    "kline.kLine.Ff3E62395B694384": "30 очков",
    "kline.kLine.C1993F9C6Db1A674": "1 час",
    "kline.kLine.Fd2Cbbae405E284C": "1 день",
    "kline.kLine.C9Cd71904395042C": "январь",
    "kline.kLine.7D8127Ec18C7B8C7": "Купить",
    "kline.kLine.E3D3Ffdb9B3E5636": "Количество (шт.)",
    "kline.kLine.6834Fec1838D8029": "Цена (USDT)",
    "kline.kLine.16C52Aae474Bc9Cd": "ордер на продажу",
    "kline.kLine.B9Bea1A9A88D1419": "Открыто длинное",
    "kline.kLine.D36Cfa96Ee2B343B": "Открыть короткую позицию",
    "other.languageRateSelect.6897784800834C1B": "настройка языка",
    "other.languageRateSelect.6897784800834C1C": "Пожалуйста, выберите валюту ценообразования",
    "other.navigationBar.F6E62F9642018Cbb": "титульная страница",
    "other.navigationBar.0Ec227161A47B49D": "Кавычки",
    "other.navigationBar.29761532Fc8Ebecc": "торговля",
    "other.navigationBar.693C7B35Bdf3E3A3": "финансы",
    "other.navigationBar.9734C54620Eb09Af": "ресурсы",

    "home.index.25Aa4Fc745150030": "король криптовалют",
    "home.index.2D6Ecf8Faaa8B124": "Быстрее, лучше, сильнее",
    "home.index.1Db26267D1041223": "Легко торгуйте более чем 1700 криптовалютами",
    "home.index.F8E18C90C3E35618": "Войти Сейчас",
    "home.index.29761532Fc8Ebecc": "торговля",
    "home.index.D8A95E4506487452": "Популярные контракты",
    "home.index.5Bd31Fab681C6E9D": "узнать больше",
    "home.index.010Ae07A09Caf221": "торговая пара",
    "home.index.F4D875118E6D6Dbb": "Последняя цена",
    "home.index.3Dfdfb3D6599100E": "24H вверх вниз",
    "home.index.28Fb39Bd41E54242": "тенденция",
    "home.index.B47A3911Bacd94C6": "Список гейнеров",
    "home.index.712910D574F43D95": "Стабильный доход",
    "home.index.5507Fd830D7Bf51F": "Лучшие стратегии, которые легко скопировать",
    "home.index.7De3D636A165E008": "норма прибыли",
    "home.index.B853F96626106912": "Займитесь майнингом",
    "home.index.213B5C96Be7Cd1F8": "дней, годовая процентная ставка",
    "home.index.213B5C96Be7Cd1F9": "Максимально покупаемый",
    "home.index.Dc710Cffe6313Bb5": "проверьте детали",
    "home.index.B92Ffc837Ecaa1Dd": "Новости",
    "home.index.6C18D67F6D19586B": "Введение в платформу",
    "home.index.6342E3C33Cb48Cd5": "Цифровая валюта — это средство обмена, в котором используются криптографические принципы для обеспечения безопасности транзакций. В отличие от бумажных валют, таких как доллар США, цифровые валюты не имеют физической формы. Популярные цифровые валюты, такие как Биткойн (BTC), Эфириум (ETH) и Polkadot (DOT), используют блокчейн в качестве базовой технологии, действуя как децентрализованный цифровой реестр. Все транзакции с цифровой валютой записываются в блокчейне и не могут быть изменены после подтверждения и проверки. В отличие от традиционных валют, где банки ведут централизованные реестры, транзакции с цифровой валютой происходят в общедоступных блокчейнах, доступ к которым может получить каждый.",
    "home.index.198Efc4254683Eef": "Кроме того, согласно механизму консенсуса, каждый может проверять транзакции цифровой валюты и добавлять их в блокчейн, достигая таким образом децентрализации. Поскольку ведущие мировые компании, такие как Samsung, BlackRock, Morgan Stanley и Alphabet, инвестировали средства, люди верят, что технология блокчейна полностью изменит глобальную финансовую систему. Цифровая валюта открывает вам дверь в мир децентрализованных финансов, позволяя вам исследовать безграничные возможности, открываемые передовыми технологиями.",
    "home.index.E710339D9576292E": "Наше преимущество",
    "home.index.F9Ce8B2C63885B26": "безопасный и стабильный",
    "home.index.C4D0A2C9Ff0305Ce": "Ведущая техническая группа самостоятельно разрабатывает высокоскоростной механизм синтеза транзакций, который по-прежнему может стабильно и надежно работать при массовых одновременных транзакциях.",
    "home.index.2E8708Ee3F11Cc1A": "Профессионально и надежно",
    "home.index.Bb12Cbcf89C56C5C": "Профессиональная операционная команда, имеющая многолетний опыт работы в сфере блокчейна и финансов, имеет соответствующую лицензию на торговлю цифровыми активами и 100% гарантию резерва.",
    "home.index.Aa4723Bfbf6808F4": "Подавайте с сердцем",
    "home.index.1Bf0204B7D3Ee230": "Выход на глобальный рынок, поддержка нескольких языков, круглосуточная работа, мощная поддержка сообщества и профессиональное обслуживание клиентов.",
    "home.index.2E7Dfd53D26F7224": "высокая производительность",
    "home.index.1C65453103B5Fcc3": "300 000 транзакций в секунду и время ответа на заказ менее 1 миллисекунды.",
    "home.index.85Ac49Ece9Dcc80B": "Торгуйте в любое время и в любом месте!",
    "home.index.2799E18842E4Ebe9": "Откройте позицию мгновенно, используя как приложение OKEX, так и веб-страницу!",
    "home.index.2Bf52Ce75E29Fc88": "Сканируйте код для загрузки",
    "home.index.88D1422B33571066": "Андроид",
    "home.index.04Ee893775563F21": "IOS",
    "home.index.04Ee893775563F22": "продукт",
    "home.index.04Ee893775563F23": "финансовый менеджмент",
    "home.index.04Ee893775563F24": "возвращаться",
    "home.index.04Ee893775563F26": "IOS & ANDROID",
    "passwod.limit":"Длина пароля должна быть больше или равна 6 символам",
    "finance.header.E5Dd9Bbdab4F52D2": "Помощь в инвестициях",
    "finance.header.5Cbf11665B91D51D": "Добавление баланса",
    "finance.index2.B1A4Be8079A937F8": "Диапазон доступной суммы для покупки",
    "finance.index2.8371E53029Dc7558": "Штраф за нарушение условий",
    "finance.index2.Bf9A2C9Bf7Ecaf04": "Коэффициент займа",
    "finance.index2.2Ad78Bbd879C4990": "Немедленная покупка",
    "finance.index2.A3B7445Ea9D7E111": "Невозможно купить",
    "finance.index2.A3B7445Ea9D7E112": "Можно купить",
    "finance.index2.87701Fe9Ad8540Dc": "Общая доступная сумма / уже куплено",
    "finance.index2.652Effdf5D1Af6A2": "Ожидаемая доходность",
    "finance.index2.D3C3C19De952Fc0C": "Дата покупки",
    "finance.index2.6C4C46Cc4Da0C281": "Текущая сумма",
    "finance.index2.3E9A6703Abd8A3E4": "Вчерашний доход",
    "finance.index2.596704E9869C8134": "Общий доход",
    "finance.index2.0A845B549624B74B": "Годовая доходность",
    "finance.index2.9A7758Cad0402366": "Текущее владение",
    "finance.index2.9A7758Cad0402367": "Записи о доходе",
    "finance.index2.8B8Ceb7610C747Eb": "История",
    "finance.index2.8B8Ceb7610C747Ec": "Записи о вложениях",
    "finance.index2.0B049108D57B9Dd5": "Досрочное изъятие",
    "finance.index2.37Ffde1Ee1D3C8D4": "Досрочно изъято",
    "finance.index2.12F6B830Aee90Efb": "Истек срок",
    "finance.index2.40E1944D8Cafbdad": "Сумма владения",
    "finance.index2.9815C4F248B624F5": "Дата покупки",
    "finance.index2.46F7Be1133B3E2C6": "Дата окончания",
    "finance.index2.Fc8643Aa7Babcce8": "Доход",
    "finance.index2.1F2B02E97721B997": "Досрочное изъятие?",
    "finance.index2.14E543A74595Efe8": "Заявка обрабатывается",
    "finance.index2.14E543A74595Efe9": "В процессе",
    "finance.index2.14E543A74595Efe0": "Завершено",
    "finance.index2.8E29Fbba37286B63": "Имя наставника",
    "finance.index2.D736C17Df71Bcdb2": "Запрашиваемая сумма",
    "finance.index2.F38884Ed4410D9F6": "Успешно запрошенная сумма",
    "finance.index2.E3347Eb6F76Eda1C": "Уже полученный доход",
    "finance.index2.0Fc0070Cb4E9F5A8": "Дата вложения",
    "finance.index2.8Efd11Be6D9F43Df": "Дата начала доходности",
    "finance.index2.16658A855F07D171": "Сумма",
    "finance.index2.184333C81Babf2F1": "Тип",
    "finance.index2.15Cba911299D4Afd": "Немедленная покупка",
    "finance.index2.Da1Cdb155Ae381Cd": "Сумма изъятия",
    "finance.index2.15Efec8F145F2608": "Текущая сумма (USDT) : ",
    "finance.index2.159253C05C270D46": "Сумма владения (USDT) : ",
    "finance.index2.Caab3A4Ba941E0E3": "Комиссия за досрочное изъятие (USDT) : ",
    "finance.index2.Fb5Fc50Cf3716723": "Можно купить",
    "finance.index2.5Dcb4Ee5C7F1F4E1": "Введите сумму",
    "finance.index2.5886C88906Cc4491": "Команда известных экспертов, которые эффективно управляют вашими финансами",
    "finance.index2.5886C88906Cc4492": "Гарантированный доход и гибкость, позволяющие зарабатывать на колебаниях рынка",
    "finance.index2.F5Af24Dbad5837Ea": "Успешное изъятие",
    "finance.index2.Be15Df7F1D76F9B2": "Сумма вложения",
    "finance.index2.Fc57951B528F3Dd3": "Можно выдать взаймы",
    "finance.index2.3F91F76109Fdbdeb": "Выдано взаймы",
    "finance.index2.F68600F93Fe31213": "Выдать взаймы",
    "finance.index2.494E47D4025Da8E6": "Погашение",
    "finance.index2.27F6657Ebf2025E3": "Сумма выдачи взаймы",
    "finance.index2.27F6657Ebf2025E4": "Сумма погашения",
    "finance.index2.631Fc4Ce8Aeee66F": "Подтвердить выдачу взаймы",
    "finance.index2.631Fc4Ce8Aeee66G": "Подтвердить погашение",
    "time.text1":"Дата начала",
    "finance.index2.631Fc4Ce8Aeee66H": "подлежит подтверждению",
}
